/* ════════════════════════════════════════════════════════════════════════
   PlayShop - Deck Builder Disney Lorcana (MVP)
   Pilote la section sections/playshop-lorcana-deck-builder.liquid.
   Backend : edge functions deck-search-cards-lorcana / deck-save (game_id=lorcana) /
             deck-list (game=lorcana) / deck-load / deck-delete.
   Règles deck : ≥60 cartes · max 4 par carte (nom+version) · max 2 encres · liste de bannissement.
   Victoire = 20 Lore. Tout en FR (matche card_catalog.name).
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CFG = window.PS_LCDB || {};
  var FN = (CFG.fnBase || 'https://ipvzpgwgujamtzztxvcu.supabase.co/functions/v1').replace(/\/$/, '');
  var CUST = CFG.customerId || null;
  var INK_ICONS = CFG.inkIcons || {};
  var RARITY_ICONS = CFG.rarityIcons || {};
  var BANNED = (CFG.banned || []).map(function (s) { return String(s).trim().toLowerCase(); });

  var LS_KEY = 'ps-lcdb-deck-v1';

  // Libellé encre (tel que stocké dans card_catalog) → slug d'asset
  var INK_SLUG = {
    'ambre': 'ambre',
    'améthyste': 'amethyste', 'amethyste': 'amethyste',
    'émeraude': 'emeraude', 'emeraude': 'emeraude',
    'rubis': 'rubis', 'saphir': 'saphir', 'acier': 'acier'
  };
  var COST_LABELS = ['0', '1', '2', '3', '4', '5', '6', '7+'];

  // ─── État du deck ───
  // cards : { [card_catalog.id] : { card, qty } }
  var state = { deckId: null, slug: null, name: '', cards: {} };
  var searchSeq = 0;          // anti-race pour les recherches concurrentes
  var searchTimer = null;
  var lastResults = [];       // dernières cartes affichées (pour réhydrater au add)
  var _cardIndex = {};        // id → carte (résout n'importe quelle tuile cliquée)
  var _pools = {};            // cache des pools par combinaison d'encres (générateur + suggestions)
  var _archByInk = {};        // cache des archétypes méta (Supabase) par combinaison d'encres
  var _currentArch = null;    // archétype méta exact courant (pilote le plan de construction étape par étape)
  var _archTargets = {};      // nom de carte (minuscule) → quantité recommandée par l'archétype (badge « Manque ×N »)
  var _suggestOpen = false;   // panneau Suggestions ouvert ?
  var _suggestTimer = null;
  var _bpOpen = false;        // plan de construction : liste complète dépliée ?
  var _suggestPhase = null;   // onglet de phase forcé (personnage/action/objet) ou null = auto
  var _chosenInks = [];       // encres choisies pour les SUGGESTIONS (n'altère PAS les filtres de recherche)
  var _lastPoolCounts = null; // nb de cartes suggérables par catégorie (badges des onglets de phase)
  var SUGGEST_CAP = 15;       // nb max de cartes affichées (et comptées) dans une catégorie de suggestions
  var beginnerOn = false;     // Mode Débutant
  var activeStep = 1;         // étape de construction active (mode débutant)
  var _welcomeHTML = '';      // panneau d'accueil (restauré quand recherche vidée)

  // ─── Helpers DOM ───
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function eur(n) { return (Number(n) || 0).toFixed(2).replace('.', ',') + ' €'; }

  // ─── Toast léger ───
  var toastEl = null, toastTimer = null;
  function toast(msg, kind) {
    if (!toastEl) {
      toastEl = el('div', 'ps-lcdb-toast');
      toastEl.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);z-index:9999;pointer-events:none;background:var(--ps-fg,#15151c);color:var(--ps-bg,#fff);padding:.7rem 1.1rem;border-radius:12px;font-weight:700;font-size:.9rem;box-shadow:0 10px 30px -8px rgba(0,0,0,.5);opacity:0;transition:opacity .2s,transform .2s;max-width:90vw;text-align:center';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.style.background = kind === 'bad' ? '#b02a30' : (kind === 'ok' ? '#2c7a3a' : 'var(--ps-fg,#15151c)');
    toastEl.style.color = '#fff';
    requestAnimationFrame(function () { toastEl.style.opacity = '1'; toastEl.style.transform = 'translateX(-50%) translateY(0)'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.style.opacity = '0'; toastEl.style.transform = 'translateX(-50%) translateY(20px)'; }, 2400);
  }

  // ─── Modèle : encres / coût / type ───
  function cardInks(card) {
    var raw = (card && card.ink != null) ? String(card.ink) : '';
    if (!raw) return [];
    return raw.split(/[-\/,]/).map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function inkSlug(label) { return INK_SLUG[String(label).toLowerCase()] || String(label).toLowerCase(); }
  function isBanned(card) {
    if (!card || !card.name) return false;
    var n = String(card.name).trim().toLowerCase();
    return BANNED.indexOf(n) !== -1;
  }
  function costBucket(c) { var n = parseInt(c, 10); if (isNaN(n)) return null; return n >= 7 ? 7 : n; }

  // Choisit la variante achetable (Shopify) : Normal en priorité, sinon la moins chère.
  function pickVariant(card) {
    var vs = (card && card.variants) || [];
    var buyable = vs.filter(function (v) { return v && v.shopify_variant_id; });
    if (!buyable.length) return null;
    var normal = buyable.filter(function (v) { return v.variant_type === 'Normal'; });
    var pool = normal.length ? normal : buyable.slice();
    pool.sort(function (a, b) { return (a.price_eur || 0) - (b.price_eur || 0); });
    return pool[0];
  }
  function unitPrice(card) {
    if (card && card.price_eur != null) return Number(card.price_eur);
    var v = pickVariant(card); return v && v.price_eur != null ? Number(v.price_eur) : 0;
  }

  // ─── Persistance locale (survit à la navigation) ───
  function persist() {
    try {
      var slim = { deckId: state.deckId, slug: state.slug, name: state.name, cards: {} };
      Object.keys(state.cards).forEach(function (id) { slim.cards[id] = { card: state.cards[id].card, qty: state.cards[id].qty }; });
      localStorage.setItem(LS_KEY, JSON.stringify(slim));
    } catch (e) { /* noop */ }
  }
  function restore() {
    try {
      var raw = localStorage.getItem(LS_KEY); if (!raw) return false;
      var d = JSON.parse(raw); if (!d || !d.cards) return false;
      state.deckId = d.deckId || null; state.slug = d.slug || null; state.name = d.name || ''; state.cards = d.cards || {};
      return true;
    } catch (e) { return false; }
  }

  // ─── Manipulation du deck ───
  function totalCount() {
    return Object.keys(state.cards).reduce(function (s, id) { return s + state.cards[id].qty; }, 0);
  }
  function addCard(card, n) {
    if (!card || !card.id) return;
    if (isBanned(card)) { toast('« ' + card.name +' » est bannie en tournoi.', 'bad'); return; }
    n = n || 1;
    pushHistory();
    var e = state.cards[card.id];
    if (e) { e.qty = Math.min(4, e.qty + n); e.card = card; }
    else { state.cards[card.id] = { card: card, qty: Math.min(4, n) }; }
    if (state.cards[card.id].qty >= 4 && (e ? (e.qty) : n) > 4) toast('Maximum 4 exemplaires par carte.', 'bad');
    afterChange();
  }
  function setQty(id, qty) {
    var e = state.cards[id]; if (!e) return;
    pushHistory();
    qty = Math.max(0, Math.min(4, qty));
    if (qty === 0) delete state.cards[id]; else e.qty = qty;
    afterChange();
  }
  function removeCard(id) { if (!state.cards[id]) return; pushHistory(); delete state.cards[id]; afterChange(); }
  function clearDeck() { pushHistory(); state = { deckId: null, slug: null, name: '', cards: {} }; _chosenInks = []; _suggestPhase = null; _currentArch = null; _archTargets = {}; var ni = $('[data-ps-lcdb-name]'); if (ni) ni.value = ''; afterChange(); }

  function afterChange() { recompute(); persist(); }

  // ─── Annuler (undo) ───
  var _history = [];
  function snapshot() { var s = {}; Object.keys(state.cards).forEach(function (id) { s[id] = { card: state.cards[id].card, qty: state.cards[id].qty }; }); return s; }
  function pushHistory() { _history.push(snapshot()); if (_history.length > 50) _history.shift(); updateUndo(); }
  function updateUndo() { var b = $('[data-ps-lcdb-action="undo"]'); if (b) b.disabled = _history.length === 0; }
  function undo() { if (!_history.length) return; state.cards = _history.pop(); afterChange(); updateUndo(); }

  // ─── Exporter (modal liste) ───
  function exportDeck() {
    var cats = { personnage: [], action: [], objet: [] };
    Object.keys(state.cards).forEach(function (id) { var e = state.cards[id]; cats[deckCatOf(e.card)].push(e); });
    var labels = { personnage: 'Personnages', action: 'Actions & Chansons', objet: 'Objets & Lieux' };
    var lines = [];
    ['personnage', 'action', 'objet'].forEach(function (cat) {
      if (!cats[cat].length) return;
      lines.push('# ' + labels[cat]);
      cats[cat].sort(function (a, b) { return String(a.card.name).localeCompare(String(b.card.name)); }).forEach(function (e) { lines.push(e.qty + 'x ' + e.card.name); });
      lines.push('');
    });
    var txt = lines.join('\n').trim() || 'Deck vide';
    var ov = el('div', 'ps-zoom-overlay'); ov.setAttribute('data-ps-lcdb-zoom', '');
    ov.innerHTML = '<div class="ps-zoom__inner" style="max-width:560px;padding:1.5rem">' +
      '<button type="button" class="ps-zoom__close" data-ps-lcdb-zoom-close aria-label="Fermer">✕</button>' +
      '<h2 class="ps-zoom__title" style="margin-top:0">Exporter le deck</h2>' +
      '<textarea readonly style="width:100%;min-height:300px;border:2px solid var(--ps-border);border-radius:10px;background:var(--ps-bg);color:var(--ps-fg);padding:.7rem;font-family:monospace;font-size:.85rem;box-sizing:border-box">' + esc(txt) + '</textarea>' +
      '<button type="button" class="ps-btn ps-btn--primary ps-btn--full" data-lz-copy style="margin-top:.6rem">Copier la liste</button></div>';
    document.body.appendChild(ov); document.body.style.overflow = 'hidden';
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('[data-ps-lcdb-zoom-close]')) closeCardZoom(); });
    var cp = ov.querySelector('[data-lz-copy]'); if (cp) cp.addEventListener('click', function () { try { navigator.clipboard.writeText(txt); cp.textContent = 'Copié ✔'; } catch (e) {} });
  }
  // ─── Partager (copie le lien si sauvegardé) ───
  function shareDeck() {
    if (!state.slug) { toast('Sauvegarde d\'abord ton deck pour le partager.', 'bad'); return; }
    var url = location.origin + '/pages/decks-lorcana?deck=' + state.slug;
    try { navigator.clipboard.writeText(url); toast('Lien du deck copié ✔', 'ok'); } catch (e) { toast(url); }
  }

  // ─── Validation des règles ───
  function deckInks() {
    var set = {};
    Object.keys(state.cards).forEach(function (id) {
      cardInks(state.cards[id].card).forEach(function (ink) { set[ink] = true; });
    });
    return Object.keys(set);
  }
  // Encres « effectives » : celles du deck, sinon celles cochées dans le filtre (choix via duo/encre).
  var INK_NAMES = { ambre: 'Ambre', amethyste: 'Améthyste', emeraude: 'Émeraude', rubis: 'Rubis', saphir: 'Saphir', acier: 'Acier' };
  function effectiveInks() {
    var inks = deckInks();
    if (inks.length) return inks;
    if (_chosenInks.length) return _chosenInks.map(function (s) { return INK_NAMES[s] || s; });
    return activeFilter($('[data-ps-lcdb-inkfilters]')).map(function (s) { return INK_NAMES[s] || s; });
  }
  // Slugs d'encre pour les pools de suggestions (deck → encres choisies → filtre manuel).
  function suggestInkSlugs() {
    var s = uniq(deckInks().map(inkSlug));
    if (s.length) return s;
    if (_chosenInks.length) return _chosenInks.slice();
    return activeFilter($('[data-ps-lcdb-inkfilters]'));
  }
  function validate() {
    var msgs = [], ok = true;
    var total = totalCount();
    var inks = deckInks();
    if (total < 60) { ok = false; msgs.push('Encore <strong>' + (60 - total) + '</strong> carte' + ((60 - total) > 1 ? 's' : '') + ' (minimum 60).'); }
    if (inks.length > 2) { ok = false; msgs.push('Trop d\'encres : <strong>' + inks.length + '</strong> (maximum 2).'); }
    var over = Object.keys(state.cards).filter(function (id) { return state.cards[id].qty > 4; });
    if (over.length) { ok = false; msgs.push('Certaines cartes dépassent 4 exemplaires.'); }
    var banned = Object.keys(state.cards).filter(function (id) { return isBanned(state.cards[id].card); });
    if (banned.length) { ok = false; msgs.push('Carte(s) bannie(s) à retirer.'); }
    if (ok) msgs.push('Deck légal ✔ - 60 cartes, ' + inks.length + ' encre' + (inks.length > 1 ? 's' : '') + ', règles respectées.');
    return { ok: ok, msgs: msgs, total: total, inks: inks };
  }

  // Bandeau Validation Format (en bas) — 2 lignes comme Pokémon + alertes de légalité seulement
  function renderValidation() {
    var ul = $('[data-ps-lcdb-validation]'); if (!ul) return;
    var total = totalCount(), inks = deckInks();
    var items = [
      '<li class="ps-deck-builder__validation-item" data-status="info">Format : <strong>Infini</strong></li>',
      '<li class="ps-deck-builder__validation-item" data-status="' + (total >= 60 ? 'ok' : 'info') + '">' + total + '/60 cartes</li>'
    ];
    if (inks.length > 2) items.push('<li class="ps-deck-builder__validation-item" data-status="warn">Trop d\'encres (' + inks.length + '/2 max)</li>');
    if (Object.keys(state.cards).some(function (id) { return state.cards[id].qty > 4; })) items.push('<li class="ps-deck-builder__validation-item" data-status="warn">Max 4 exemplaires par carte dépassé</li>');
    if (Object.keys(state.cards).some(function (id) { return isBanned(state.cards[id].card); })) items.push('<li class="ps-deck-builder__validation-item" data-status="warn">Carte(s) bannie(s) à retirer</li>');
    ul.innerHTML = items.join('');
  }

  // ─── Rendu : recompute tout le builder ───
  function recompute() {
    var v = validate();
    var total = v.total;

    // Score rafraîchi en tout premier : aucun autre rendu ne peut le figer (fix retrait).
    try { renderScore(); } catch (e) {}

    var countEl = $('[data-ps-lcdb-count]'); if (countEl) countEl.textContent = total;
    var prog = $('[data-ps-lcdb-progress]'); if (prog) prog.style.setProperty('--pct', Math.min(100, (total / 60) * 100) + '%');

    // Compteurs par catégorie (Personnages / Actions+Chansons / Objets+Lieux)
    var n = deckTypeCounts();
    var catMap = { personnage: n.personnage, action: n.action + n.chanson, objet: n.objet + n.lieu };
    Object.keys(catMap).forEach(function (cat) { var s = $('[data-ps-lcdb-cat="' + cat + '"] strong'); if (s) s.textContent = catMap[cat]; });

    // Encres (inline dans le résumé)
    var inksEl = $('[data-ps-lcdb-inks]');
    if (inksEl) {
      if (!v.inks.length) inksEl.textContent = 'Aucune encre';
      else inksEl.innerHTML = v.inks.map(function (ink) {
        var ic = INK_ICONS[inkSlug(ink)];
        return (ic ? '<img src="' + esc(ic) + '" alt="" style="width:14px;height:14px;vertical-align:-2px;margin-right:2px">' : '') + esc(ink);
      }).join(' · ');
    }

    // Rendus isolés : un échec d'un rendu ne doit JAMAIS bloquer les autres (score déjà fait plus haut).
    try { renderDeckList(); } catch (e) {}
    try { renderChecks(); } catch (e) {}
    try { renderCurve(); } catch (e) {}
    try { renderValidation(); } catch (e) {}
    try { renderGuide(); } catch (e) {}
    try { renderBuildPlan(); } catch (e) {}
    try { renderPhases(); } catch (e) {}

    // Total prix + dispo + boutons
    var totalPrice = 0, anyBuyable = false;
    Object.keys(state.cards).forEach(function (id) {
      var e = state.cards[id]; totalPrice += unitPrice(e.card) * e.qty;
      if (pickVariant(e.card)) anyBuyable = true;
    });
    var t1 = $('[data-ps-lcdb-total]'); if (t1) t1.textContent = eur(totalPrice);
    var t2 = $('[data-ps-lcdb-total-detail]'); if (t2) t2.textContent = eur(totalPrice);
    var avail = $('[data-ps-lcdb-availability]'); if (avail) avail.textContent = total ? (anyBuyable ? 'Disponible' : 'Indisponible') : '-';
    var buyBtn = $('[data-ps-lcdb-action="buy"]'); if (buyBtn) buyBtn.disabled = !anyBuyable || total === 0;
    var drawBtn = $('[data-ps-lcdb-action="draw-hand"]'); if (drawBtn) drawBtn.disabled = total < 1;

    syncResultQtyBadges();
    scheduleSuggest();
  }

  // Répartition par coût d'ENCRE (pas le prix !) : une ligne par coût, barre qui se remplit vers la droite.
  function renderCurve() {
    var wrap = $('[data-ps-lcdb-curve]'); if (!wrap) return;
    var buckets = [0, 0, 0, 0, 0, 0, 0, 0];
    Object.keys(state.cards).forEach(function (id) {
      var e = state.cards[id], b = costBucket(e.card.cost);
      if (b != null) buckets[b] += e.qty;
    });
    var max = Math.max.apply(null, buckets) || 1;
    wrap.hidden = false;
    wrap.innerHTML = buckets.map(function (n, i) {
      var pct = n ? Math.max(6, Math.round((n / max) * 100)) : 0;
      return '<div class="ps-lcdb__cv-row"' + (n ? '' : ' data-empty="1"') + ' title="' + n + ' carte(s) à ' + COST_LABELS[i] + ' ⬡ d\'encre">' +
        '<span class="ps-lcdb__cv-cost">' + COST_LABELS[i] + '</span>' +
        '<span class="ps-lcdb__cv-track"><span class="ps-lcdb__cv-fill" style="width:' + pct + '%"></span></span>' +
        '<span class="ps-lcdb__cv-n">' + n + '</span>' +
      '</div>';
    }).join('');
  }

  function renderTypeBreak() {
    var wrap = $('[data-ps-lcdb-typebreak]'); if (!wrap) return;
    var counts = {};
    Object.keys(state.cards).forEach(function (id) {
      var e = state.cards[id], t = e.card.type || '-';
      counts[t] = (counts[t] || 0) + e.qty;
    });
    var keys = Object.keys(counts);
    if (!keys.length) { wrap.innerHTML = ''; return; }
    var order = ['Personnage', 'Action', 'Chanson', 'Objet', 'Lieu'];
    keys.sort(function (a, b) { var ia = order.indexOf(a), ib = order.indexOf(b); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); });
    wrap.innerHTML = keys.map(function (k) {
      return '<span class="ps-lcdb__type-pill">' + esc(k) + ' · <strong>' + counts[k] + '</strong></span>';
    }).join('');
  }

  // Catégorie d'affichage du deck (3 colonnes comme Pokémon) : chanson→action, lieu→objet
  function deckCatOf(card) {
    var k = typeKey(card);
    if (k === 'chanson') return 'action';
    if (k === 'lieu') return 'objet';
    if (k === 'personnage' || k === 'action' || k === 'objet') return k;
    return 'objet';
  }
  function buildDeckCard(e) {
    var c = e.card;
    var li = el('li', 'ps-deck-builder__deck-card');
    li.setAttribute('data-card-id', c.id);
    if (isBanned(c)) li.style.outline = '2px solid #e0555e';
    var img = c.image_url
      ? '<img src="' + esc(c.image_url) + '" alt="' + esc(c.name) + '" loading="lazy">'
      : '<div class="ps-deck-builder__deck-card-placeholder"><span>🃏</span></div>';
    // Badge « Manque ×N » / « ✓ Optimal » selon la quantité recommandée par l'archétype méta (parité Pokémon).
    var tgt = _archTargets[(c.name || '').toLowerCase()] || 0;
    var targetBadge = '';
    if (tgt > 0) {
      if (e.qty < tgt) targetBadge = '<span class="ps-deck-card-target ps-deck-card-target--missing" title="Le deck méta recommande ×' + tgt + '. Tu en as ' + e.qty + '.">Manque ×' + (tgt - e.qty) + '</span>';
      else targetBadge = '<span class="ps-deck-card-target ps-deck-card-target--ok" title="Quantité optimale ×' + tgt + ' atteinte.">✓ Optimal</span>';
    }
    li.innerHTML =
      '<div class="ps-deck-builder__deck-card-visual" title="' + esc(c.name) + '">' +
        img +
        '<span class="ps-deck-builder__deck-card-qty-badge" aria-hidden="true">×' + e.qty + '</span>' +
        '<div class="ps-deck-builder__deck-card-controls" aria-label="Contrôles quantité">' +
          '<button type="button" data-deck-action="dec" aria-label="Retirer 1">−</button>' +
          '<button type="button" data-deck-action="inc" aria-label="Ajouter 1">+</button>' +
          '<button type="button" data-deck-action="remove" aria-label="Supprimer cette carte">🗑</button>' +
        '</div>' +
      '</div>' +
      (targetBadge ? '<div class="ps-deck-card-target-wrap">' + targetBadge + '</div>' : '');
    return li;
  }
  function renderDeckList() {
    var cats = { personnage: [], action: [], objet: [] };
    Object.keys(state.cards).forEach(function (id) { var e = state.cards[id]; cats[deckCatOf(e.card)].push(e); });
    var emptyTxt = { personnage: 'Aucun personnage ajouté.', action: 'Aucune action ajoutée.', objet: 'Aucun objet ajouté.' };
    ['personnage', 'action', 'objet'].forEach(function (cat) {
      var ul = $('[data-ps-lcdb-deck-cards="' + cat + '"]'); if (!ul) return;
      var list = cats[cat];
      if (!list.length) { ul.innerHTML = '<li class="ps-deck-builder__deck-empty">' + emptyTxt[cat] + '</li>'; return; }
      list.sort(function (a, b) {
        var xa = parseInt(a.card.cost, 10) || 0, xb = parseInt(b.card.cost, 10) || 0;
        if (xa !== xb) return xa - xb;
        return String(a.card.name).localeCompare(String(b.card.name));
      });
      ul.innerHTML = '';
      list.forEach(function (e) { ul.appendChild(buildDeckCard(e)); });
    });
  }

  // ─── Recherche ───
  function activeFilter(group) {
    return $$('button.is-active', group).map(function (b) { return b.getAttribute('data-ink') || b.getAttribute('data-type'); }).filter(Boolean);
  }
  function runSearch() {
    var input = $('[data-ps-lcdb-search]');
    var q = input ? input.value.trim() : '';
    var inks = activeFilter($('[data-ps-lcdb-inkfilters]'));
    var types = activeFilter($('[data-ps-lcdb-typefilters]'));
    var costs = $$('button.is-active', $('[data-ps-lcdb-costfilters]')).map(function (b) { return b.getAttribute('data-cost'); }).filter(Boolean);
    var rarities = $$('button.is-active', $('[data-ps-lcdb-rarityfilters]')).map(function (b) { return b.getAttribute('data-rarity'); }).filter(Boolean);
    var inkwellSel = $$('button.is-active', $('[data-ps-lcdb-inkwellfilters]')).map(function (b) { return b.getAttribute('data-inkwell'); }).filter(Boolean);
    var inkwell = (inkwellSel.length === 1) ? inkwellSel[0] : '';
    var setSel = $('[data-ps-lcdb-filter-set]'); var setId = setSel ? setSel.value : '';
    var budgetEl = $('[data-ps-lcdb-filter-budget]'); var budget = budgetEl ? (parseInt(budgetEl.value, 10) || 0) : 0;
    var instockEl = $('[data-ps-lcdb-filter-instock]'); var instock = !!(instockEl && instockEl.checked);
    var clr = $('[data-ps-lcdb-search-clear]'); if (clr) clr.hidden = !q;
    var results = $('[data-ps-lcdb-results]'); if (!results) return;

    var hasFilter = inks.length || types.length || costs.length || rarities.length || inkwell || setId || budget > 0 || instock;
    if (!q && !hasFilter) {
      results.innerHTML = _welcomeHTML || '<p class="ps-lcdb__empty">Cherche une carte par nom, ou filtre par encre / type pour commencer.</p>';
      return;
    }
    var params = new URLSearchParams();
    if (q) params.set('q', q);
    if (inks.length) params.set('ink', inks.join(','));
    if (types.length) params.set('type', types.join(','));
    if (costs.length) params.set('cost', costs.join(','));
    if (rarities.length) params.set('rarity', rarities.join(','));
    if (inkwell) params.set('inkwell', inkwell);
    if (setId) params.set('set_id', setId);
    if (budget > 0) params.set('budget_max', String(budget));
    if (instock) params.set('in_stock_only', 'true');
    params.set('limit', '60');

    var mySeq = ++searchSeq;
    results.innerHTML = '<p class="ps-lcdb__empty">Recherche…</p>';
    fetch(FN + '/deck-search-cards-lorcana?' + params.toString())
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (mySeq !== searchSeq) return; // une recherche plus récente a gagné
        lastResults = (data && data.cards) || [];
        renderResults(lastResults);
      })
      .catch(function () {
        if (mySeq !== searchSeq) return;
        results.innerHTML = '<p class="ps-lcdb__empty">Erreur de recherche. Réessaie.</p>';
      });
  }
  // Lettre de variante Lorcana (Normal → N, Brillant → B, …)
  var VARIANT_LETTER = { 'Normal': 'N', 'Brillant': 'B', 'Brillante': 'B', 'Foil': 'F', 'Holo': 'H', 'Enchanted': 'E', 'Enchanté': 'E', 'Enchantée': 'E', 'Promo': 'P' };
  function variantLetter(t) { if (!t) return '?'; return VARIANT_LETTER[t] || String(t).charAt(0).toUpperCase(); }

  // Carte de résultat = markup PRODUIT officiel (.ps-cl__item > .ps-card) — search ET suggestions.
  function buildSearchCardLi(card, opts) {
    opts = opts || {};
    _cardIndex[card.id] = card;
    var qty = state.cards[card.id] ? state.cards[card.id].qty : 0;
    var banned = isBanned(card);
    var maxed = qty >= 4 || banned;
    var safe = esc(card.name);
    var visual = card.image_url
      ? '<img class="ps-card__img ps-card__img--primary" src="' + esc(card.image_url) + '" alt="' + safe + '" loading="lazy" onerror="this.outerHTML=\'<div class=ps-card__ph>🃏</div>\';">'
      : '<div class="ps-card__ph">🃏</div>';
    var variants = card.variants || [];
    var variantsClass = 'ps-card__variants' + (variants.length <= 1 ? ' ps-card__variants--single' : '');
    var variantsHTML;
    if (variants.length) {
      variantsHTML = variants.slice(0, 4).map(function (v) {
        var price = v.price_eur == null ? 'Indispo' : eur(v.price_eur);
        return '<form class="ps-card__variant-form" onsubmit="return false">' +
          '<button type="button" class="ps-card__cta ps-card__cta--variant ps-card__cta--out-of-stock" data-deck-add-qty="1"' + (maxed ? ' disabled' : '') + ' aria-label="' + safe + ' ' + esc(v.variant_type || '') + ' ' + price + '">' +
            (variants.length > 1 ? '<span class="ps-card__cta-variant-name">' + variantLetter(v.variant_type) + '</span>' : '<span class="ps-card__cta-variant-name" aria-hidden="true" style="visibility:hidden">.</span>') +
            '<span class="ps-card__cta-variant-state">' + price + '</span>' +
          '</button></form>';
      }).join('');
    } else {
      variantsHTML = '<form class="ps-card__variant-form" onsubmit="return false"><button type="button" class="ps-card__cta ps-card__cta--variant" disabled><span class="ps-card__cta-variant-name" aria-hidden="true" style="visibility:hidden">.</span><span class="ps-card__cta-variant-state">Rupture</span></button></form>';
    }
    var addBtns =
      '<button type="button" class="ps-deck-builder__add1" data-deck-add-qty="1" aria-label="Ajouter 1"' + (maxed ? ' disabled' : '') + '>+1</button>' +
      '<button type="button" class="ps-deck-builder__add4" data-deck-add-qty="4" aria-label="Ajouter 4"' + (maxed ? ' disabled' : '') + '>+4</button>';
    var total = (card.metadata && card.metadata.tcg_card_total) ? card.metadata.tcg_card_total : '';
    var ref = card.card_local_id ? (card.card_local_id + (total ? '/' + total : '')) : '';
    var titleHTML = ref
      ? '<h3 class="ps-card__title ps-card__title--split"><span class="ps-card__title-prefix">' + esc(ref) + '</span><span class="ps-card__title-rest">' + safe + '</span></h3>'
      : '<h3 class="ps-card__title">' + safe + '</h3>';
    // 🏆 Top choix : signale les cartes les plus fortes de la catégorie (parité Pokémon).
    var topChoiceTitle = opts.topTitle || 'Meilleur rapport Lore + Volonté + Force pour son coût d\'encre (dans tes encres)';
    var topChoiceHTML = opts.topPick
      ? '<span class="ps-card__top-choice-dot" title="' + esc(topChoiceTitle) + '" aria-label="Top choix">🏆</span>'
      : '';
    var li = el('li', 'ps-cl__item');
    li.innerHTML =
      '<div class="ps-card' + (maxed && !banned ? ' ps-card--maxed' : '') + '" data-card-id="' + esc(card.id) + '"' + (banned ? ' style="outline:2px solid #e0555e"' : '') + '>' +
        '<div class="ps-card__link">' +
          '<div class="ps-card__media">' + visual + topChoiceHTML + addBtns + '</div>' +
          '<div class="ps-card__info">' + titleHTML + '<div class="' + variantsClass + '">' + variantsHTML + '</div></div>' +
        '</div>' +
      '</div>';
    var mediaEl = li.querySelector('.ps-card__media');
    if (mediaEl) {
      mediaEl.style.cursor = 'zoom-in';
      mediaEl.addEventListener('click', function (e) { if (e.target.closest('[data-deck-add-qty]')) return; e.preventDefault(); openCardZoom(card); });
    }
    li.querySelectorAll('[data-deck-add-qty]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); if (btn.disabled) return; addCard(card, parseInt(btn.getAttribute('data-deck-add-qty'), 10) || 1); });
    });
    return li;
  }

  function renderResults(cards) {
    var results = $('[data-ps-lcdb-results]'); if (!results) return;
    if (!cards.length) { results.innerHTML = '<p class="ps-deck-builder__results-empty">Aucune carte trouvée.</p>'; lockSearchHeight(); return; }
    results.innerHTML = '';
    cards.forEach(function (c) { results.appendChild(buildSearchCardLi(c)); });
    lockSearchHeight();
  }
  // Verrouille la hauteur de la colonne recherche sur celle du bloc filtres (desktop) → scroll interne, jamais de débordement
  var _lockT = null;
  function lockSearchHeight() {
    var s = document.querySelector('.ps-ldeck .ps-deck-builder__search');
    var f = document.querySelector('.ps-ldeck .ps-deck-builder__stats');
    if (!s || !f) return;
    if (window.innerWidth <= 899) { if (s.style.height) s.style.height = ''; return; }
    var h = Math.round(f.getBoundingClientRect().height);
    if (h <= 0) return; // bloc caché (onglet inactif) → ne touche pas
    var cur = parseInt(s.style.height, 10) || 0;
    if (Math.abs(cur - h) > 2) s.style.height = h + 'px'; // garde anti-boucle ResizeObserver
  }
  // Synchronise l'état maxed + boutons des cartes affichées sans refetch
  function syncResultQtyBadges() {
    $$('.ps-card[data-card-id]').forEach(function (cardEl) {
      var id = cardEl.getAttribute('data-card-id'); var c = _cardIndex[id];
      var qty = state.cards[id] ? state.cards[id].qty : 0;
      var maxed = qty >= 4 || (c && isBanned(c));
      cardEl.classList.toggle('ps-card--maxed', !!(qty >= 4) && !(c && isBanned(c)));
      cardEl.querySelectorAll('[data-deck-add-qty]').forEach(function (b) { b.disabled = !!maxed; });
    });
  }

  // ─── Modal zoom (mêmes classes .ps-zoom__* que la fiche, adapté Lorcana) ───
  function lzEsc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  // handleize FR comme Shopify/Liquid (pour reconstruire le handle de collection chapitre)
  function lzHandleize(s) {
    return String(s || '').toLowerCase()
      .replace(/[àâä]/g, 'a').replace(/[éèêë]/g, 'e').replace(/[îï]/g, 'i').replace(/[ôö]/g, 'o').replace(/[ûüù]/g, 'u').replace(/ç/g, 'c')
      .replace(/['’`]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  // Parse les capacités Lorcana (jsonb : tableau OU chaîne JSON)
  function lzParseAbilities(m) {
    var a = m && m.lorcana_abilities; if (!a) return [];
    if (typeof a === 'string') { try { a = JSON.parse(a); } catch (e) { return []; } }
    return Array.isArray(a) ? a : [];
  }
  function closeCardZoom() { var ex = document.querySelector('[data-ps-lcdb-zoom]'); if (ex) { ex.remove(); document.body.style.overflow = ''; } }
  function openCardZoom(card) {
    if (!card) return; closeCardZoom();
    var m = card.metadata || {}, inks = cardInks(card);
    var title = m.shopify_title || ((card.card_local_id ? card.card_local_id + ' - ' : '') + card.name);
    var visual = card.image_url
      ? '<img src="' + lzEsc(card.image_url) + '" alt="' + lzEsc(card.name) + '" class="ps-zoom__image" draggable="false" oncontextmenu="return false;">'
      : '<div style="aspect-ratio:5/7;display:grid;place-items:center;background:var(--ps-bg);border-radius:12px"><span style="font-size:3rem;opacity:.5">🃏</span></div>';
    var illuName = m.tcg_illustrator || '';
    var illu = illuName ? '<p class="ps-zoom__illu">Illustré par <strong>' + lzEsc(illuName) + '</strong></p>' : '';
    // Eyebrow chapitre → lien vers la collection (handle = lorcana-{slug}-{set_id}, comme la fiche)
    var setName = m.tcg_set_name || '';
    var setHandle = setName ? ('lorcana-' + lzHandleize(setName) + '-' + (card.set_id || '')) : '';
    var setEyebrow = setName
      ? '<p class="ps-zoom__set"><a href="/collections/' + lzEsc(setHandle) + '">' + lzEsc(setName) + '</a></p>'
      : '';
    var version = m.lorcana_version ? '<p style="margin:-8px 0 0;font-size:.95rem;font-weight:600;color:var(--ps-fg-muted)">' + lzEsc(m.lorcana_version) + '</p>' : '';
    // Specs (ordre + Type pleine largeur identiques à la fiche)
    var specs = '';
    if (inks.length) {
      var icons = inks.map(function (i) { var u = INK_ICONS[inkSlug(i)]; return u ? '<img src="' + u + '" alt="" width="18" height="18">' : ''; }).join('');
      specs += '<li><strong>Encre</strong><span class="ps-zoom__pill">' + icons + ' ' + lzEsc(inks.join('-')) + '</span></li>';
    }
    if (card.cost != null) specs += '<li><strong>Coût</strong><span>' + lzEsc(card.cost) + ' ⬡</span></li>';
    if (card.strength != null) specs += '<li><strong>Force</strong><span>' + lzEsc(card.strength) + ' ¤</span></li>';
    if (card.willpower != null) specs += '<li><strong>Volonté</strong><span>' + lzEsc(card.willpower) + ' ⛉</span></li>';
    if (card.lore != null) specs += '<li><strong>Lore</strong><span>' + lzEsc(card.lore) + ' ◊</span></li>';
    if (card.rarity) { var isQuest = (card.rarity === 'Spécial'); var ri = isQuest ? '' : RARITY_ICONS[card.rarity]; var rlabel = isQuest ? 'Quêtes des Illumineurs' : card.rarity; specs += '<li><strong>Rareté</strong><span class="ps-zoom__pill">' + (ri ? '<img src="' + ri + '" alt="" width="18" height="18"> ' : '') + lzEsc(rlabel) + '</span></li>'; }
    var inkable = (m.lorcana_inkwell === true || m.lorcana_inkwell === 'true');
    var inkwellIc = inkable ? (CFG.inkwellIcon || '') : (CFG.inklessIcon || '');
    specs += '<li><strong>Encrier</strong><span class="ps-zoom__pill">' + (inkwellIc ? '<img src="' + inkwellIc + '" alt="" width="18" height="18"> ' : '') + (inkable ? 'Encrable' : 'Non encrable') + '</span></li>';
    if (card.type) specs += '<li style="grid-column:1 / -1;"><strong>Type</strong><span style="text-align:right;">' + lzEsc(card.type) + (m.lorcana_subtypes ? ' - ' + lzEsc(m.lorcana_subtypes) : '') + '</span></li>';
    // Capacités (parsées depuis lorcana_abilities → noms colorés ALTER / GEL INTENSE + texte rappel)
    var abilities = lzParseAbilities(m);
    var abilitiesHTML = '';
    if (abilities.length) {
      var items = abilities.map(function (ab) {
        var nm = ab.keyword ? (ab.keyword + (ab.keywordValue ? ' ' + ab.keywordValue : '')) : (ab.name || '');
        var body = ab.reminderText ? '<em>' + lzEsc(ab.reminderText) + '</em>' : (ab.effect ? lzEsc(ab.effect) : '');
        return '<div class="ps-zoom__ability">' + (nm ? '<h4 class="ps-zoom__ability-name">' + lzEsc(nm) + '</h4>' : '') + (body ? '<p class="ps-zoom__ability-effect">' + body + '</p>' : '') + '</div>';
      }).join('');
      abilitiesHTML = '<div class="ps-zoom__block ps-zoom__block--ability"><h3 class="ps-zoom__block-title"><span aria-hidden="true">✨</span> Capacités</h3>' + items + '</div>';
    } else if (m.lorcana_full_text) {
      abilitiesHTML = '<div class="ps-zoom__block"><h3 class="ps-zoom__block-title"><span aria-hidden="true">✨</span> Capacités</h3><p class="ps-zoom__ability-effect" style="margin:0;white-space:pre-line">' + lzEsc(m.lorcana_full_text) + '</p></div>';
    }
    var fiche = card.shopify_handle ? '<a href="/products/' + lzEsc(card.shopify_handle) + '" target="_blank" rel="noopener" class="ps-zoom__cta">Voir La Fiche Complète</a>' : '';
    var ov = el('div', 'ps-zoom-overlay'); ov.setAttribute('data-ps-lcdb-zoom', '');
    ov.innerHTML =
      '<div class="ps-zoom__inner">' +
        '<button type="button" class="ps-zoom__close" data-ps-lcdb-zoom-close aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
        '<div class="ps-zoom__grid">' +
          '<div class="ps-zoom__media">' + visual + illu + '</div>' +
          '<div class="ps-zoom__info">' + setEyebrow + '<h2 class="ps-zoom__title"><span>' + lzEsc(title) + '</span></h2>' + version + '<ul class="ps-zoom__specs">' + specs + '</ul>' + abilitiesHTML + fiche + '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ov); document.body.style.overflow = 'hidden';
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('[data-ps-lcdb-zoom-close]')) closeCardZoom(); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCardZoom(); });

  // ─── Sauvegarde / chargement / achat ───
  function saveDeck() {
    if (!CUST) { toast('Connecte-toi pour sauvegarder.', 'bad'); return; }
    var ni = $('[data-ps-lcdb-name]');
    var name = (ni ? ni.value : '').trim() || ('Deck Lorcana ' + new Date().toLocaleDateString('fr-FR'));
    state.name = name;
    var cards = Object.keys(state.cards).map(function (id, idx) {
      var e = state.cards[id];
      return { card_id: id, variant_id: e.card.default_variant_id || ((pickVariant(e.card) || {}).id) || null, quantity: e.qty, slot_type: 'main', position: idx };
    });
    if (!cards.length) { toast('Ton deck est vide.', 'bad'); return; }
    var btn = $('[data-ps-lcdb-action="save"]'); if (btn) btn.disabled = true;
    fetch(FN + '/deck-save', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: CUST, deck_id: state.deckId, name: name, format: 'infini', game_id: 'lorcana', cards: cards })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (btn) btn.disabled = false;
      if (res && res.success) {
        state.deckId = res.deck_id; state.slug = res.slug; persist();
        toast('Deck sauvegardé ✔', 'ok');
      } else { toast('Échec de la sauvegarde' + (res && res.error ? ' : ' + res.error : ''), 'bad'); }
    }).catch(function () { if (btn) btn.disabled = false; toast('Erreur réseau.', 'bad'); });
  }

  function buyDeck() {
    var items = [];
    Object.keys(state.cards).forEach(function (id) {
      var e = state.cards[id], v = pickVariant(e.card);
      if (v && v.shopify_variant_id) items.push({ id: Number(v.shopify_variant_id), quantity: e.qty });
    });
    if (!items.length) { toast('Aucune carte achetable dans ce deck.', 'bad'); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { toast('Erreur lors de l\'ajout au panier.', 'bad'); });
  }

  function loadDeckBySlug(slug) {
    if (!slug) return;
    var params = new URLSearchParams(); params.set('slug', slug); if (CUST) params.set('customer_id', CUST);
    fetch(FN + '/deck-load?' + params.toString()).then(function (r) { return r.json(); }).then(function (data) {
      if (!data || !data.deck) { toast('Deck introuvable.', 'bad'); return; }
      state = { deckId: data.deck.id, slug: data.deck.slug, name: data.deck.name || '', cards: {} };
      (data.cards || []).forEach(function (row) {
        var c = row.card; if (!c) return;
        // Normalise vers la forme attendue (search expose ink/cost/type en top-level ; load les laisse dans metadata)
        var m = c.metadata || {};
        c.ink = c.ink != null ? c.ink : (m.lorcana_ink || null);
        c.cost = c.cost != null ? c.cost : (m.lorcana_cost != null ? m.lorcana_cost : null);
        c.type = c.type != null ? c.type : (m.lorcana_type || null);
        c.lore = c.lore != null ? c.lore : (m.lorcana_lore != null ? m.lorcana_lore : null);
        if (c.inkwell == null) c.inkwell = (m.lorcana_inkwell === true || m.lorcana_inkwell === 'true');
        state.cards[c.id] = { card: c, qty: row.quantity || 1 };
      });
      var ni = $('[data-ps-lcdb-name]'); if (ni) ni.value = state.name;
      persist(); recompute();
      toast('Deck « ' + state.name + ' » chargé.', 'ok');
    }).catch(function () { toast('Erreur de chargement.', 'bad'); });
  }

  // ─── Bibliothèque (onglet) — cartes riches IDENTIQUES au hub Pokémon (.ps-deck-hub__*) ───
  var FORMAT_LABELS = { infini: 'Infini', standard: 'Standard', core: 'Core' };
  var _libDecks = [];

  function formatPrice(v) { var n = parseFloat(v); return (n && n > 0) ? eur(n) : ''; }

  function renderLibCreateCard() {
    var li = el('li', 'ps-deck-hub__card ps-deck-hub__card--create');
    li.innerHTML =
      '<a href="#construire" data-ps-ldeck-tab="build" class="ps-deck-hub__card-link">' +
        '<span class="ps-deck-hub__card-create-icon" aria-hidden="true">+</span>' +
        '<span class="ps-deck-hub__card-create-label">Nouveau Deck</span>' +
      '</a>';
    return li;
  }

  function renderLibCard(d) {
    var li = el('li', 'ps-deck-hub__card');
    var cc = d.card_count || 0;
    var complete = cc >= 60;
    var pct = Math.min(100, Math.round((cc / 60) * 100));
    var fmt = FORMAT_LABELS[d.format] || (d.format || '');
    var price = formatPrice(d.total_price_eur);
    var thumb = d.thumbnail_url
      ? '<img src="' + esc(d.thumbnail_url) + '" alt="' + esc(d.name || '') + '" loading="lazy" />'
      : '<span class="ps-deck-hub__card-thumb-empty" aria-hidden="true">🃏</span>';
    var fmtBadge = fmt ? '<span class="ps-deck-hub__fmt">' + esc(fmt) + '</span>' : '';
    var countRow = '<div class="ps-deck-hub__count' + (complete ? ' is-complete' : '') + '">' +
        '<div class="ps-deck-hub__count-bar"><span style="width:' + pct + '%"></span></div>' +
        '<span class="ps-deck-hub__count-label">' + cc + '/60' + (complete ? ' ✓' : '') + '</span>' +
      '</div>';
    var priceRow = price
      ? '<div class="ps-deck-hub__price">' + price + '</div>'
      : '<div class="ps-deck-hub__price ps-deck-hub__price--empty">Deck vide</div>';
    li.innerHTML =
      '<a href="/pages/decks-lorcana?deck=' + esc(d.slug) + '" class="ps-deck-hub__card-link">' +
        '<div class="ps-deck-hub__card-thumb">' + thumb + fmtBadge + '</div>' +
        '<div class="ps-deck-hub__card-body">' +
          '<span class="ps-deck-hub__card-title">' + esc(d.name || 'Deck') + '</span>' +
          countRow + priceRow +
        '</div>' +
      '</a>' +
      '<button type="button" class="ps-deck-hub__card-delete" aria-label="Supprimer ce deck" title="Supprimer ce deck" data-deck-slug="' + esc(d.slug || '') + '" data-deck-name="' + esc(d.name || 'Deck') + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>' +
      '</button>';
    return li;
  }

  function sortLibDecks(decks, mode) {
    var arr = decks.slice();
    if (mode === 'price-desc') arr.sort(function (a, b) { return (parseFloat(b.total_price_eur) || 0) - (parseFloat(a.total_price_eur) || 0); });
    else if (mode === 'price-asc') arr.sort(function (a, b) { return (parseFloat(a.total_price_eur) || 0) - (parseFloat(b.total_price_eur) || 0); });
    else if (mode === 'cards') arr.sort(function (a, b) { return (b.card_count || 0) - (a.card_count || 0); });
    return arr; // 'recent' = ordre serveur (updated_at desc)
  }

  function updateLibCount() {
    var c = $('[data-ps-lcdb-libcount]'); if (!c) return;
    var n = _libDecks.length; c.textContent = n + ' deck' + (n > 1 ? 's' : '');
  }

  function fillLibGrid(grid, decks) {
    grid.setAttribute('aria-busy', 'false');
    grid.innerHTML = '';
    grid.appendChild(renderLibCreateCard());
    decks.forEach(function (d) { grid.appendChild(renderLibCard(d)); });
  }

  function loadLibrary() {
    var grid = $('[data-ps-lcdb-library]'); if (!grid || !CUST) return;
    var params = new URLSearchParams(); params.set('category', 'mine'); params.set('game', 'lorcana'); params.set('customer_id', CUST); params.set('limit', '500');
    // `category=mine` = decks privés ⇒ identité par jeton (customer_id ignoré côté serveur).
    fetch(FN + '/deck-list?' + params.toString(), { headers: { 'x-ps-token': window.PS_AUTH_TOKEN || '' } }).then(function (r) { return r.json(); }).then(function (data) {
      _libDecks = (data && data.decks) || [];
      updateLibCount();
      var sel = $('[data-ps-lcdb-sort]');
      if (sel && !sel._wired) { sel._wired = true; sel.addEventListener('change', function () { fillLibGrid(grid, sortLibDecks(_libDecks, sel.value)); }); }
      fillLibGrid(grid, sortLibDecks(_libDecks, sel ? sel.value : 'recent'));
    }).catch(function () { grid.setAttribute('aria-busy', 'false'); });
  }
  window.PS_LCDB_loadLibrary = loadLibrary;

  // Toast de confirmation (mêmes classes que le hub Pokémon → CSS partagé playshop-deck-hub.css)
  function confirmToast(message, onYes) {
    var prev = document.querySelector('.ps-deck-toast'); if (prev) prev.remove();
    var t = el('div', 'ps-deck-toast');
    t.innerHTML = '<div class="ps-deck-toast__box" role="alertdialog" aria-modal="true" aria-label="Confirmation">' +
        '<p class="ps-deck-toast__msg">' + message + '</p>' +
        '<div class="ps-deck-toast__actions">' +
          '<button type="button" class="ps-deck-toast__btn ps-deck-toast__btn--yes">Oui</button>' +
          '<button type="button" class="ps-deck-toast__btn ps-deck-toast__btn--no">Non</button>' +
        '</div></div>';
    document.body.appendChild(t);
    function close() { t.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    t.addEventListener('click', function (e) { if (e.target === t) close(); });
    t.querySelector('.ps-deck-toast__btn--no').addEventListener('click', close);
    t.querySelector('.ps-deck-toast__btn--yes').addEventListener('click', function () { close(); onYes(); });
  }

  function deleteDeck(slug, btn) {
    if (!CUST || !slug) return;
    btn.disabled = true;
    fetch(FN + '/deck-delete', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ slug: slug, customer_id: CUST }) })
      .then(function (r) { return r.json(); }).then(function (res) {
        if (res && res.success) {
          if (state.slug === slug) clearDeck();
          var li = btn.closest('.ps-deck-hub__card'); if (li) li.remove();
          _libDecks = _libDecks.filter(function (d) { return d.slug !== slug; });
          updateLibCount();
        } else { btn.disabled = false; toast('Échec de la suppression.', 'bad'); }
      }).catch(function () { btn.disabled = false; toast('Erreur réseau.', 'bad'); });
  }
  function goToBuild() {
    document.documentElement.setAttribute('data-ps-ldeck-tab', 'build');
    $$('.ps-deck-tabs__btn').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-ps-ldeck-tab') === 'build'); });
    try { history.replaceState(null, '', location.pathname + '#construire'); } catch (e) {}
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ════════════════════════════════════════════════════════════
  //  MOTEUR : type, score, suggestions, génération automatique
  // ════════════════════════════════════════════════════════════
  function uniq(a) { var s = {}, o = []; a.forEach(function (x) { if (!s[x]) { s[x] = 1; o.push(x); } }); return o; }
  function typeKey(c) {
    var t = (c && c.type ? String(c.type) : '').toLowerCase();
    if (t.indexOf('personnage') >= 0) return 'personnage';
    if (t.indexOf('chanson') >= 0) return 'chanson';
    if (t.indexOf('action') >= 0) return 'action';
    if (t.indexOf('objet') >= 0) return 'objet';
    if (t.indexOf('lieu') >= 0) return 'lieu';
    return 'autre';
  }
  function deckTypeCounts() {
    var n = { personnage: 0, action: 0, chanson: 0, objet: 0, lieu: 0 };
    Object.keys(state.cards).forEach(function (id) { var e = state.cards[id], k = typeKey(e.card); if (n[k] != null) n[k] += e.qty; });
    return n;
  }
  function scoreColor(s) { if (s >= 80) return '#1f9d57'; if (s >= 55) return '#b9852b'; if (s >= 30) return '#d98324'; return '#c0392b'; }

  // ─── Score 0-100 + checklist (heuristiques de la réf deckbuilding Lorcana) ───
  function deckScoreBreakdown() {
    var total = totalCount();
    var chars = 0, lore2 = 0, inkable = 0, buckets = [0, 0, 0, 0, 0, 0, 0, 0];
    Object.keys(state.cards).forEach(function (id) {
      var e = state.cards[id], c = e.card, q = e.qty, tk = typeKey(c);
      if (tk === 'personnage') { chars += q; if ((Number(c.lore) || 0) >= 2) lore2 += q; }
      if (c.inkwell) inkable += q;
      var b = costBucket(c.cost); if (b != null) buckets[b] += q;
    });
    var inks = deckInks();
    var mid = buckets[2] + buckets[3] + buckets[4];
    var midShare = total ? mid / total : 0;
    var charShare = total ? chars / total : 0;
    var inkShare = total ? inkable / total : 0;

    var sCount = Math.round(Math.min(1, total / 60) * 25);
    var sInk = (inks.length >= 1 && inks.length <= 2) ? 10 : 0;
    var sCurve = Math.round(Math.min(1, midShare / 0.55) * 20);
    var sChar = Math.round(Math.min(1, charShare / 0.66) * 15);
    var sLore = Math.round(Math.min(1, lore2 / 12) * 15);
    var sInkable = Math.round(Math.min(1, inkShare / 0.75) * 15);
    var score = Math.max(0, Math.min(100, sCount + sInk + sCurve + sChar + sLore + sInkable));

    var parts = [
      { label: 'Taille du deck', val: total + '/60', ok: total >= 60 },
      { label: 'Encres', val: inks.length + ' / 2 max', ok: inks.length >= 1 && inks.length <= 2 },
      { label: 'Courbe (coût 2-4)', val: Math.round(midShare * 100) + '%', ok: midShare >= 0.45 },
      { label: 'Personnages', val: chars, ok: chars >= 38 },
      { label: 'Moteur de Lore (Lore ≥ 2)', val: lore2, ok: lore2 >= 10 },
      { label: 'Cartes encrables', val: inkable + '/' + total, ok: inkShare >= 0.7 }
    ];
    return { score: score, parts: parts, total: total };
  }
  function renderScore() {
    var e2 = $('[data-ps-lcdb-score]'); if (!e2) return;
    var btn = e2.closest('[data-ps-lcdb-score-toggle]') || e2;
    if (totalCount() === 0) {
      btn.hidden = true;
      var bdz = $('[data-ps-lcdb-score-breakdown]'); if (bdz) bdz.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      return;
    }
    var b = deckScoreBreakdown();
    btn.hidden = false;
    btn.style.setProperty('--sc', scoreColor(b.score));
    e2.innerHTML = 'SCORE <strong>' + b.score + '</strong><small>/100</small>';
    btn.title = 'Score de préparation du deck (' + b.score + '/100) - clic pour le détail';
  }
  function renderChecks() {
    var ul = $('[data-ps-lcdb-checks]'); if (!ul) return;
    if (totalCount() === 0) { ul.innerHTML = ''; return; }
    var b = deckScoreBreakdown();
    ul.innerHTML = b.parts.map(function (p) {
      return '<li class="' + (p.ok ? 'ok' : 'warn') + '"><span class="ic" aria-hidden="true">' + (p.ok ? '✅' : '⚠️') + '</span><span><b>' + esc(p.label) + '</b> - ' + esc(String(p.val)) + '</span></li>';
    }).join('');
  }

  // ─── Mode Débutant : étapes de construction ───
  function setBeginner(on) {
    beginnerOn = !!on;
    try { localStorage.setItem('ps-lcdb-beginner', beginnerOn ? '1' : '0'); } catch (e) {}
    var cb = $('[data-ps-lcdb-beginner]'); if (cb) cb.checked = beginnerOn;
    var guide = $('[data-ps-lcdb-guide]'); if (guide) guide.hidden = !beginnerOn;
    renderSteps();
    renderGuide();
  }
  // Barre de guide adaptative (style Pokémon) — montre l'étape courante selon l'état du deck.
  // ON LA GARDE (comme Pokémon) : guide en haut + Plan de construction dans les Suggestions.
  function renderGuide() {
    if (!beginnerOn) return;
    var guide = $('[data-ps-lcdb-guide]'); if (!guide) return;
    var numEl = $('[data-ps-lcdb-guide-num]'), titleEl = $('[data-ps-lcdb-guide-title]'), textEl = $('[data-ps-lcdb-guide-text]'), pctEl = $('[data-ps-lcdb-guide-pct]');
    var total = totalCount(), inks = effectiveInks(), n = deckTypeCounts(), step, title, text;
    if (!inks.length) { step = '1'; title = 'Étape 1/4 : Choisis tes encres'; text = 'Choisis une encre ou un duo (débutant : Ambre + Améthyste, facile et abordable). Le builder te guide ensuite étape par étape.'; }
    else if (n.personnage < 40) { step = '2'; title = 'Étape 2/4 : Ajoute des Personnages'; text = 'Vise ~40 Personnages (' + n.personnage + '/40) - ce sont eux qui gagnent du Lore. Clique « ✨ » pour compléter automatiquement.'; }
    else if (n.action + n.chanson < 14) { step = '3'; title = 'Étape 3/4 : Actions & Chansons'; text = 'Ajoute ~14 Actions/Chansons (' + (n.action + n.chanson) + '/14) pour piocher et gérer les menaces.'; }
    else if (total < 60) { step = '4'; title = 'Étape 4/4 : Complète à 60'; text = 'Ajoute des Objets/Lieux et atteins 60 cartes (' + total + '/60).'; }
    else { step = '✓'; title = 'Deck complet ✔'; text = 'Ton deck est légal à 60 cartes. Sauvegarde-le, ou affine-le avec les suggestions.'; }
    if (numEl) numEl.textContent = step;
    if (titleEl) titleEl.textContent = title;
    if (textEl) textEl.textContent = text;
    if (pctEl) pctEl.textContent = Math.min(100, Math.round(total / 60 * 100)) + '%';
    guide.classList.toggle('ps-deck-builder__guide--done', total >= 60);
  }
  function renderSteps() {
    var wrap = $('[data-ps-lcdb-steps]'); if (!wrap) return;
    if (!beginnerOn) { wrap.hidden = true; wrap.innerHTML = ''; return; }
    wrap.hidden = false;
    var n = deckTypeCounts();
    var steps = [
      { n: 1, label: 'Personnages', cur: n.personnage, tgt: 40, types: ['personnage'] },
      { n: 2, label: 'Actions & Chansons', cur: n.action + n.chanson, tgt: 14, types: ['action', 'chanson'] },
      { n: 3, label: 'Objets & Lieux', cur: n.objet + n.lieu, tgt: 6, types: ['objet', 'lieu'] }
    ];
    wrap.innerHTML = steps.map(function (s) {
      var done = s.cur >= s.tgt;
      return '<button type="button" class="ps-lcdb__step' + (s.n === activeStep ? ' is-active' : '') + '" data-step="' + s.n + '" data-types="' + s.types.join(',') + '">' +
        '<span class="ps-lcdb__step-n">' + (done ? '✓' : s.n) + '</span>' + esc(s.label) + ' ' + s.cur + '/' + s.tgt + '</button>';
    }).join('');
  }
  function setTypeFilter(types) {
    var grp = $('[data-ps-lcdb-typefilters]'); if (!grp) return;
    $$('.ps-lcdb__chip', grp).forEach(function (chip) {
      chip.classList.toggle('is-active', types.indexOf(chip.getAttribute('data-type')) !== -1);
    });
    runSearch();
  }
  function setCostFilter(costs) {
    var grp = $('[data-ps-lcdb-costfilters]'); if (!grp) return;
    $$('.ps-lcdb__chip', grp).forEach(function (chip) {
      chip.classList.toggle('is-active', costs.indexOf(chip.getAttribute('data-cost')) !== -1);
    });
  }

  // ─── Plan de construction guidé (rule-based, parité Pokémon) ───
  function deckCharByBucket() {
    var b = [0, 0, 0, 0, 0, 0, 0, 0];
    Object.keys(state.cards).forEach(function (id) {
      var e = state.cards[id]; if (typeKey(e.card) === 'personnage') { var k = costBucket(e.card.cost); if (k != null) b[k] += e.qty; }
    });
    return b;
  }
  function inkableCount() {
    var s = 0; Object.keys(state.cards).forEach(function (id) { var e = state.cards[id]; if (e.card.inkwell) s += e.qty; }); return s;
  }
  // Combien d'exemplaires de CES cartes (par nom) sont déjà dans le deck.
  function deckCountByNames(names) {
    var set = {}; (names || []).forEach(function (nm) { set[(nm || '').toLowerCase()] = 1; });
    var s = 0; Object.keys(state.cards).forEach(function (id) { var e = state.cards[id]; if (set[(e.card.name || '').toLowerCase()]) s += e.qty; });
    return s;
  }
  // Plan GÉNÉRIQUE (aucun archétype détecté) : la méthode universelle de construction Lorcana.
  function genericBuildSteps() {
    var n = deckTypeCounts(), cb = deckCharByBucket(), total = totalCount(), inkable = inkableCount();
    var low = cb[1] + cb[2], mid = cb[3] + cb[4], big = cb[5] + cb[6] + cb[7];
    return [
      { role: 'Petits personnages (coût 1-2)', cur: low, tgt: 14, types: ['personnage'], costs: ['1', '2'],
        x: 'Des personnages à <b>faible coût d\'encre</b> (idéalement <b>encrables</b>) pour poser du tempo dès les 1ers tours et garder une courbe basse.' },
      { role: 'Cœur du deck (coût 3-4)', cur: mid, tgt: 16, types: ['personnage'], costs: ['3', '4'],
        x: 'Tes moteurs de Lore : vise des personnages à <b>Lore ≥ 2</b> avec une bonne Volonté pour survivre aux défis.' },
      { role: 'Finisseurs (coût 5+)', cur: big, tgt: 8, types: ['personnage'], costs: ['5', '6', '7,8,9,10'],
        x: 'Quelques gros corps / bombes pour reprendre le plateau et conclure la course au Lore.' },
      { role: 'Actions & Chansons', cur: n.action + n.chanson, tgt: 14, types: ['action', 'chanson'], costs: [],
        x: 'Pioche, removal et tempo. Les <b>Chansons</b> se jouent gratuitement en épuisant un personnage de coût suffisant.' },
      { role: 'Objets & Lieux', cur: n.objet + n.lieu, tgt: 5, types: ['objet', 'lieu'], costs: [],
        x: 'Objets de valeur/soin et Lieux qui génèrent du Lore passif en début de tour.' },
      { role: 'Finalise à 60', cur: total, tgt: 60, finale: true, types: [], costs: [],
        x: 'Atteins 60 cartes et garde ~45 cartes <b>encrables</b> (' + inkable + ' actuellement) pour ne jamais bloquer ta réserve.' }
    ];
  }
  // Plan SPÉCIFIQUE À L'ARCHÉTYPE : on monte CE deck méta, étape par étape, avec ses vraies cartes + le pourquoi.
  function archetypeBuildSteps(arch) {
    var cards = arch.cards || [];
    function isChar(c) { return (c.type || '').toLowerCase().indexOf('personnage') >= 0; }
    function isAct(c) { var t = (c.type || '').toLowerCase(); return t.indexOf('action') >= 0 || t.indexOf('chanson') >= 0; }
    function isObjLieu(c) { var t = (c.type || '').toLowerCase(); return t.indexOf('objet') >= 0 || t.indexOf('lieu') >= 0; }
    function band(c) { var x = parseInt(c.cost, 10); return isNaN(x) ? 9 : x; }
    var low = cards.filter(function (c) { return isChar(c) && band(c) <= 2; });
    var mid = cards.filter(function (c) { return isChar(c) && band(c) >= 3 && band(c) <= 4; });
    var big = cards.filter(function (c) { return isChar(c) && band(c) >= 5; });
    var act = cards.filter(isAct);
    var obj = cards.filter(isObjLieu);
    function tgt(arr) { var s = 0; arr.forEach(function (c) { s += (c.count_typical || 0); }); return s; }
    function cur(arr) { return deckCountByNames(arr.map(function (c) { return c.card_name; })); }
    function names(arr) { return arr.slice().sort(function (a, b) { return (b.count_typical || 0) - (a.count_typical || 0); }).map(function (c) { return c.card_name; }); }
    function txt(arr) { var ns = names(arr); return lzEsc(ns.slice(0, 4).join(', ')) + (ns.length > 4 ? '…' : ''); }
    var steps = [];
    if (low.length) steps.push({ role: 'Petits personnages (coût 1-2)', cur: cur(low), tgt: tgt(low), types: ['personnage'], costs: ['1', '2'],
      x: 'Tes cartes peu coûteuses en encre : tu les poses dès les 1ers tours pour marquer du Lore tôt et ne jamais rester sans jeu. Dans ce deck : <b>' + txt(low) + '</b>.' });
    if (mid.length) steps.push({ role: 'Cœur du deck (coût 3-4)', cur: cur(mid), tgt: tgt(mid), types: ['personnage'], costs: ['3', '4'],
      x: 'Le moteur de l\'archétype - les personnages autour desquels le deck est construit. Dans ce deck : <b>' + txt(mid) + '</b>.' });
    if (big.length) steps.push({ role: 'Finisseurs (coût 5+)', cur: cur(big), tgt: tgt(big), types: ['personnage'], costs: ['5', '6', '7,8,9,10'],
      x: 'Tes grosses menaces qui reprennent le plateau et concluent la course au Lore. Dans ce deck : <b>' + txt(big) + '</b>.' });
    if (act.length) steps.push({ role: 'Actions & Chansons', cur: cur(act), tgt: tgt(act), types: ['action', 'chanson'], costs: [],
      x: 'Removal, pioche et tempo - les <b>Chansons</b> se jouent gratuitement en épuisant un personnage de coût suffisant. Dans ce deck : <b>' + txt(act) + '</b>.' });
    if (obj.length) steps.push({ role: 'Objets & Lieux', cur: cur(obj), tgt: tgt(obj), types: ['objet', 'lieu'], costs: [],
      x: 'Valeur, soin et Lore passif (les Lieux génèrent du Lore en début de tour). Dans ce deck : <b>' + txt(obj) + '</b>.' });
    steps.push({ role: 'Finalise à 60', cur: totalCount(), tgt: 60, finale: true, types: [], costs: [],
      x: 'Ajuste jusqu\'à 60 cartes en respectant les quantités de la liste méta (4× pour le cœur, 2-3× pour les compléments). Garde assez de cartes <b>encrables</b> pour ne jamais bloquer ta réserve.' });
    return steps;
  }
  function buildPlanSteps() {
    if (_currentArch && (_currentArch.cards || []).length) return archetypeBuildSteps(_currentArch);
    return genericBuildSteps();
  }
  function renderBuildPlan() {
    var box = $('[data-ps-lcdb-buildplan]'); if (!box) return;
    var inks = effectiveInks();
    if (!inks.length) { box.hidden = true; box.innerHTML = ''; return; } // pas encore d'encre choisie
    var steps = buildPlanSteps();
    var done = steps.filter(function (s) { return s.cur >= s.tgt; }).length;
    var active = null, ai = 0;
    for (var i = 0; i < steps.length; i++) { if (steps[i].cur < steps[i].tgt) { active = steps[i]; ai = i; break; } }
    box.hidden = false;
    var total = totalCount();
    var pct = Math.round(done / steps.length * 100);
    // Structure 100% identique à Pokémon (classes .ps-build-plan__* du CSS partagé).
    var html = '';
    html += '<div class="ps-build-plan__header">' +
      '<div class="ps-build-plan__title"><span class="ps-build-plan__title-icon">🎯</span><span>Plan de construction <strong>' + esc(inks.join(' / ')) + '</strong></span></div>' +
      '<div class="ps-build-plan__progress-text">' + done + ' / ' + steps.length + ' étapes</div></div>';
    html += '<div class="ps-build-plan__progress-bar"><div class="ps-build-plan__progress-fill" style="width:' + pct + '%"></div></div>';
    // Plan de jeu de l'archétype (le « pourquoi » global) au-dessus des étapes.
    if (_currentArch && _currentArch.win_condition) {
      html += '<div class="ps-build-plan__notes" style="margin:.1rem 0 .7rem;opacity:.92">🎯 <b>Plan de jeu :</b> ' + lzEsc(_currentArch.win_condition) + '</div>';
    }
    if (!active) {
      html += '<div class="ps-build-plan__current ps-build-plan__current--done"><span class="ps-build-plan__check">✅</span>' +
        '<span>' + (total >= 60 ? 'Deck complet à ' + total + '/60 - prêt à jouer ! 🎉' : 'Toutes les briques sont là. Affine et teste ta main d\'ouverture !') + '</span></div>';
    } else {
      html += '<div class="ps-build-plan__current"><div class="ps-build-plan__current-info">' +
        '<div class="ps-build-plan__step-label">Étape ' + (ai + 1) + ' / ' + steps.length + ' · ' + esc(active.role) + '</div>' +
        '<div class="ps-build-plan__card-name">' + esc(active.role) + ' <span class="ps-build-plan__qty">(' + active.cur + '/' + active.tgt + ')</span></div>' +
        '<div class="ps-build-plan__notes">' + active.x + '</div></div>' +
        (active.finale
          ? '<button type="button" class="ps-build-plan__add-btn" data-ps-lcdb-action="autofill">✨ Compléter</button>'
          : '<button type="button" class="ps-build-plan__add-btn" data-ps-lcdb-bp-find data-types="' + active.types.join(',') + '" data-costs="' + active.costs.join('|') + '">Voir les cartes</button>') +
        '</div>';
    }
    html += '<div class="ps-build-plan__actions">';
    if (active && total < 60) html += '<button type="button" class="ps-build-plan__complete-btn" data-ps-lcdb-action="autofill">🚀 Compléter le deck en 1 clic</button>';
    html += '<button type="button" class="ps-build-plan__toggle" data-ps-lcdb-bp-toggle>' + (_bpOpen ? '▲ Masquer toutes les étapes' : '▼ Voir toutes les étapes') + '</button>';
    html += '</div>';
    if (_bpOpen) {
      html += '<ul class="ps-build-plan__steps">' + steps.map(function (s, i) {
        var dn = s.cur >= s.tgt, isCur = (i === ai && active);
        var icon = dn ? '✅' : (isCur ? '🎯' : '⏳');
        var cls = dn ? ' ps-build-plan__step--done' : (isCur ? ' ps-build-plan__step--current' : '');
        return '<li class="ps-build-plan__step' + cls + '"><span class="ps-build-plan__step-icon">' + icon + '</span><span class="ps-build-plan__step-num">' + (i + 1) + '.</span><span class="ps-build-plan__step-name">' + esc(s.role) + '</span><span class="ps-build-plan__step-role"></span><span class="ps-build-plan__step-progress">' + s.cur + '/' + s.tgt + '</span></li>';
      }).join('') + '</ul>';
    }
    box.innerHTML = html;
  }

  // ─── Pools de cartes par encre (cache) → suggestions + générateur ───
  function fetchPool(inkParam, type, limit) {
    var p = new URLSearchParams(); p.set('ink', inkParam); p.set('type', type); p.set('limit', String(limit));
    return fetch(FN + '/deck-search-cards-lorcana?' + p.toString())
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.cards) || []; })
      .catch(function () { return []; });
  }
  function getPools(inkSlugs) {
    var key = inkSlugs.slice().sort().join(',');
    if (_pools[key]) return Promise.resolve(_pools[key]);
    var inkParam = inkSlugs.join(',');
    return Promise.all([
      fetchPool(inkParam, 'personnage', 100),
      fetchPool(inkParam, 'action', 60),
      fetchPool(inkParam, 'chanson', 40),
      fetchPool(inkParam, 'objet', 40),
      fetchPool(inkParam, 'lieu', 20)
    ]).then(function (r) {
      var pools = { chars: r[0], actions: r[1].concat(r[2]), objects: r[3], locations: r[4] };
      _pools[key] = pools; return pools;
    });
  }
  // ─── Archétypes méta (vrais decks classés S/A/B/C en Supabase) → boost des cartes clés ───
  function getArchetypes(inkSlugs) {
    var key = inkSlugs.slice().sort().join(',');
    if (_archByInk[key]) return Promise.resolve(_archByInk[key]);
    return fetch(FN + '/deck-archetypes-lorcana?inks=' + encodeURIComponent(inkSlugs.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (d) { var a = (d && d.archetypes) || []; _archByInk[key] = a; return a; })
      .catch(function () { return []; });
  }
  // Score de puissance brute d'un personnage : Lore (objectif du jeu) > Volonté (survie) > Force.
  function charPower(c) {
    var lore = Number(c.lore) || 0, will = Number(c.willpower) || 0, str = Number(c.strength) || 0, cost = Number(c.cost) || 0;
    var kw = String(c.keywords || (c.metadata && c.metadata.lorcana_keywords) || '');
    var bonus = 0;
    if (/Insaisissable|Evasive/i.test(kw)) bonus += 1.5;   // difficile à défier → file du Lore
    if (/Garde du corps|Bodyguard/i.test(kw)) bonus += 0.8; // protège le banc
    if (/Précipité|Rush/i.test(kw)) bonus += 0.6;
    if (/Soutien|Support/i.test(kw)) bonus += 0.5;
    // efficacité par rapport au coût (un 2-coût à 2 Lore vaut mieux qu'un 6-coût à 2 Lore)
    var eff = (lore * 2.2 + will * 0.9 + str * 0.7) - cost * 0.35;
    return eff + bonus;
  }
  function charQuality(a, b) {
    var ai = a.inkwell ? 1 : 0, bi = b.inkwell ? 1 : 0; if (ai !== bi) return bi - ai;
    var pa = charPower(a), pb = charPower(b); if (pb !== pa) return pb - pa;
    var ap = a.price_eur == null ? 999 : a.price_eur, bp = b.price_eur == null ? 999 : b.price_eur; return ap - bp;
  }
  function genQuality(a, b) {
    var ai = a.inkwell ? 1 : 0, bi = b.inkwell ? 1 : 0; if (ai !== bi) return bi - ai;
    var ap = a.price_eur == null ? 999 : a.price_eur, bp = b.price_eur == null ? 999 : b.price_eur; return ap - bp;
  }
  // Pénalité d'achat : une version Enchantée/foil à 50-180 € n'a rien à faire dans un deck à jouer.
  // On rabaisse fortement ces cartes pour qu'elles ne « volent » jamais le haut des suggestions.
  function pricePenalty(c) { var p = c.price_eur == null ? 0 : c.price_eur; return p > 6 ? (p - 6) * 0.6 : 0; }
  // Valeur d'une carte dans les suggestions : force de jeu réelle (Lore/Volonté/Force) moins une pénalité de PRIX en € (≠ coût d'encre).
  function suggestValueChar(c) { return charPower(c) - pricePenalty(c); }
  function suggestValueOther(c) {
    // Actions/Objets/Lieux : pas de stat de combat → on valorise l'accessibilité (encrable + abordable).
    var v = c.inkwell ? 1.2 : 0; var p = c.price_eur == null ? 1 : c.price_eur;
    return v - Math.min(p, 6) * 0.15 - pricePenalty(c);
  }
  // Tranche de coût ciblée par l'étape « personnages » en cours (parité avec le plan de construction).
  function activeCharCostBand() {
    var cb = deckCharByBucket();
    var low = cb[1] + cb[2], mid = cb[3] + cb[4], big = cb[5] + cb[6] + cb[7];
    if (low < 14) return { 1: 1, 2: 1 };           // Étape 1 : petits personnages (coût 1-2)
    if (mid < 16) return { 3: 1, 4: 1 };           // Étape 2 : cœur du deck (coût 3-4)
    if (big < 8) return { 5: 1, 6: 1, 7: 1 };      // Étape 3 : finisseurs (coût 5+)
    return null;                                   // courbe perso complète → plus de priorité de tranche
  }

  // ─── Suggestions intelligentes (heuristique, sans seed) ───
  function scheduleSuggest() { if (!_suggestOpen) return; clearTimeout(_suggestTimer); _suggestTimer = setTimeout(refreshSuggestions, 350); }
  function toggleSuggest() {
    _suggestOpen = !_suggestOpen;
    var body = $('[data-ps-lcdb-suggest-body]'), tg = $('[data-ps-lcdb-suggest-toggle]'), car = $('[data-ps-lcdb-suggest-caret]');
    if (body) body.style.display = _suggestOpen ? '' : 'none';
    if (tg) tg.setAttribute('aria-expanded', _suggestOpen ? 'true' : 'false');
    if (car) car.style.transform = _suggestOpen ? 'rotate(180deg)' : '';
    if (_suggestOpen) refreshSuggestions();
  }
  // Test main d'ouverture : pioche 7 cartes au hasard du deck
  function drawHand() {
    var box = $('[data-ps-lcdb-hand]'), ul = $('[data-ps-lcdb-hand-cards]'), verdict = $('[data-ps-lcdb-hand-verdict]'); if (!box || !ul) return;
    var pool = [];
    Object.keys(state.cards).forEach(function (id) { var e = state.cards[id]; for (var i = 0; i < e.qty; i++) pool.push(e.card); });
    if (pool.length < 7) { toast('Ajoute au moins 7 cartes pour piocher une main.', 'bad'); return; }
    for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = pool[i]; pool[i] = pool[j]; pool[j] = t; }
    var hand = pool.slice(0, 7);
    ul.innerHTML = hand.map(function (c) { return '<li><img src="' + esc(c.image_url || '') + '" alt="' + esc(c.name) + '" loading="lazy" title="' + esc(c.name) + '"></li>'; }).join('');
    var inkable = hand.filter(function (c) { return c.inkwell; }).length;
    var lowChars = hand.filter(function (c) { return typeKey(c) === 'personnage' && (parseInt(c.cost, 10) || 9) <= 3; }).length;
    var ok = inkable >= 3 && lowChars >= 1;
    if (verdict) verdict.innerHTML = ok
      ? '✅ Bonne main : ' + inkable + ' encrables, ' + lowChars + ' personnage(s) jouable(s) tôt.'
      : '⚠️ Main risquée : ' + inkable + ' encrable(s), ' + lowChars + ' petit(s) perso. Vise ≥ 3 encrables.';
    box.hidden = false;
  }
  function resetFilters() {
    $$('[data-ps-lcdb-inkfilters] button, [data-ps-lcdb-typefilters] button, [data-ps-lcdb-costfilters] button, [data-ps-lcdb-rarityfilters] button, [data-ps-lcdb-inkwellfilters] button').forEach(function (c) { c.classList.remove('is-active'); });
    var si = $('[data-ps-lcdb-search]'); if (si) si.value = '';
    var setSel = $('[data-ps-lcdb-filter-set]'); if (setSel) setSel.value = '';
    var b = $('[data-ps-lcdb-filter-budget]'); if (b) { b.value = 0; var o = $('[data-ps-lcdb-budget-output]'); if (o) o.textContent = 'illimité'; }
    var ins = $('[data-ps-lcdb-filter-instock]'); if (ins) ins.checked = false;
    runSearch();
  }
  // Empty state : choix d'une encre OU d'un duo méta (clic = active la/les encre(s) dans les filtres).
  function renderStarterDecks(grid, hint) {
    grid.classList.remove('ps-lcdb__suggest-grid--starters');
    grid.classList.add('ps-lcdb__suggest-grid--inkpick');
    if (hint) hint.innerHTML = '<b>Commence par choisir ton encre</b>';
    var inks = [['ambre', 'Ambre'], ['amethyste', 'Améthyste'], ['emeraude', 'Émeraude'], ['rubis', 'Rubis'], ['saphir', 'Saphir'], ['acier', 'Acier']];
    var singles = inks.map(function (p) {
      var ic = INK_ICONS[p[0]];
      return '<button type="button" class="ps-energy-chip" data-ps-lcdb-inkpick="' + p[0] + '" title="' + esc(p[1]) + '" aria-label="' + esc(p[1]) + '">' + (ic ? '<img src="' + esc(ic) + '" alt="' + esc(p[1]) + '" loading="lazy">' : esc(p[1])) + '</button>';
    }).join('');
    // Duos méta qui fonctionnent bien ensemble
    var duos = [
      ['amethyste', 'saphir', 'Améthyste / Saphir'],
      ['ambre', 'amethyste', 'Ambre / Améthyste'],
      ['emeraude', 'saphir', 'Émeraude / Saphir'],
      ['ambre', 'emeraude', 'Ambre / Émeraude'],
      ['amethyste', 'acier', 'Améthyste / Acier'],
      ['rubis', 'amethyste', 'Rubis / Améthyste']
    ];
    var duoHtml = duos.map(function (d) {
      var i1 = INK_ICONS[d[0]], i2 = INK_ICONS[d[1]];
      return '<button type="button" class="ps-lcdb__duochip" data-ps-lcdb-inkpick-duo="' + d[0] + ',' + d[1] + '" title="' + esc(d[2]) + '" aria-label="' + esc(d[2]) + '">' +
        '<span class="ps-lcdb__duochip-icons">' + (i1 ? '<img src="' + esc(i1) + '" alt="">' : '') + (i2 ? '<img src="' + esc(i2) + '" alt="">' : '') + '</span>' +
        '<span class="ps-lcdb__duochip-label">' + esc(d[2]) + '</span></button>';
    }).join('');
    grid.innerHTML =
      '<div class="ps-lcdb__inkpick-singles">' + singles + '</div>' +
      '<p class="ps-lcdb__inkpick-or">- ou un duo qui fonctionne bien ensemble -</p>' +
      '<div class="ps-lcdb__inkpick-duos">' + duoHtml + '</div>';
  }
  // Catégorie auto = la plus en retard sur sa cible.
  function autoFocusCat() {
    var n = deckTypeCounts();
    var needChar = 40 - n.personnage, needAct = 14 - (n.action + n.chanson), needObj = 6 - (n.objet + n.lieu);
    if (needChar >= needAct && needChar >= needObj && needChar > 0) return 'personnage';
    if (needAct > 0) return 'action';
    if (needObj > 0) return 'objet';
    return 'personnage';
  }
  // Onglets de phase (Personnages / Actions & Chansons / Objets & Lieux) — visibles dès qu'une encre est choisie.
  function renderPhases() {
    var nav = $('[data-ps-lcdb-phases]'); if (!nav) return;
    if (!effectiveInks().length) { nav.hidden = true; nav.innerHTML = ''; return; }
    nav.hidden = false;
    // Badge = nb de cartes SUGGÉRABLES dans la catégorie (comme Pokémon), pas le compte du deck.
    var c = _lastPoolCounts || { personnage: 0, action: 0, objet: 0 };
    var active = _suggestPhase || autoFocusCat();
    var phases = [
      { key: 'personnage', icon: '🃏', label: 'Personnages', cur: c.personnage },
      { key: 'action', icon: '🎬', label: 'Actions & Chansons', cur: c.action },
      { key: 'objet', icon: '💎', label: 'Objets & Lieux', cur: c.objet }
    ];
    nav.innerHTML = phases.map(function (p, i) {
      var arrow = i > 0 ? '<span class="ps-suggestions-phase__arrow" aria-hidden="true">→</span>' : '';
      return arrow + '<button type="button" class="ps-suggestions-phase' + (p.key === active ? ' ps-suggestions-phase--active' : '') + '" data-ps-lcdb-phase="' + p.key + '" aria-pressed="' + (p.key === active) + '">' +
        '<span class="ps-suggestions-phase__icon" aria-hidden="true">' + p.icon + '</span>' +
        '<span class="ps-suggestions-phase__label">' + p.label + '</span>' +
        '<span class="ps-suggestions-phase__count">' + p.cur + '</span></button>';
    }).join('');
  }
  function refreshSuggestions() {
    var grid = $('[data-ps-lcdb-suggest-grid]'), hint = $('[data-ps-lcdb-suggest-hint]'); if (!grid) return;
    renderPhases();
    var actions = $('.ps-lcdb__suggest-actions');
    var inks = suggestInkSlugs().slice(0, 2);
    if (!inks.length) { renderStarterDecks(grid, hint); if (actions) actions.hidden = true; return; }
    // Transition propre intro → suggestions : si on quitte l'écran « choisis ton encre »,
    // on vide tout de suite l'intro (sinon les encres restent affichées pendant le fetch = résidu).
    var wasIntro = grid.classList.contains('ps-lcdb__suggest-grid--starters') || grid.classList.contains('ps-lcdb__suggest-grid--inkpick');
    grid.classList.remove('ps-lcdb__suggest-grid--starters');
    grid.classList.remove('ps-lcdb__suggest-grid--inkpick');
    if (actions) actions.hidden = false;
    if (hint) hint.textContent = 'Analyse de ton deck…';
    if (wasIntro) grid.innerHTML = '<p class="ps-lcdb__empty">Analyse de tes encres…</p>';
    Promise.all([getPools(inks), getArchetypes(inks)]).then(function (res) {
      var pools = res[0], archs = res[1] || [];
      var total = totalCount(), n = deckTypeCounts();
      // Archétype guide : match exact (duo) en priorité, sinon le meilleur archétype contenant l'encre choisie (mono).
      // Le boost se concentre sur CET archétype (pas un mélange) → 🏆 sur ses vraies cartes clés.
      var primaryArch = null;
      for (var ai = 0; ai < archs.length; ai++) { if (archs[ai].match === 'exact') { primaryArch = archs[ai]; break; } }
      if (!primaryArch && archs.length) primaryArch = archs[0];   // mono-encre → meilleur tier contenant cette encre
      var archImp = {};   // nom de carte (minuscule) → importance méta (1-5)
      if (primaryArch) (primaryArch.cards || []).forEach(function (cc) { var k = (cc.card_name || '').toLowerCase(); archImp[k] = cc.importance || 3; });
      var hasArch = Object.keys(archImp).length > 0;
      // Le plan de construction se cale sur l'archétype EXACT (duo) → étapes spécifiques au deck. Mono-encre → plan générique.
      _currentArch = (primaryArch && primaryArch.match === 'exact') ? primaryArch : null;
      // Quantités recommandées par carte → badge « Manque ×N » sous les cartes du deck (parité Pokémon).
      _archTargets = {};
      if (_currentArch) (_currentArch.cards || []).forEach(function (cc) { _archTargets[(cc.card_name || '').toLowerCase()] = cc.count_typical || 0; });
      try { renderBuildPlan(); renderDeckList(); } catch (e) {}
      function metaImp(c) { return archImp[(c.name || '').toLowerCase()] || 0; }
      // Besoin d'encre ? On vise ~66 % d'encrables. Tant qu'on n'y est pas → on ne propose QUE des encrables.
      var inkable = inkableCount();
      var needInk = (total === 0) ? true : (inkable / total) < 0.66;
      // Une carte = un nom. Plusieurs impressions (normal / Enchantée à 3 €) → on garde la MOINS chère, jamais de doublon.
      function dedupByName(arr) {
        var seen = {}, out = [];
        (arr || []).forEach(function (c) {
          var key = (c.name || '').toLowerCase(); var prev = seen[key];
          if (!prev) { seen[key] = c; out.push(c); return; }
          var pPrev = prev.price_eur == null ? 9999 : prev.price_eur, pCur = c.price_eur == null ? 9999 : c.price_eur;
          if (pCur < pPrev) { out[out.indexOf(prev)] = c; seen[key] = c; }
        });
        return out;
      }
      // Cartes réellement proposables : jouables (< 4 ex, non bannies), dédoublonnées, et encrables tant qu'on manque d'encre.
      function curate(p) {
        var arr = (p || []).filter(function (c) { var cur = state.cards[c.id] ? state.cards[c.id].qty : 0; return cur < 4 && !isBanned(c); });
        arr = dedupByName(arr);
        // Tant qu'on manque d'encre : on ne garde que les encrables — SAUF les cartes de l'archétype méta (même non encrables, elles font partie du deck).
        if (needInk) { var inkOnly = arr.filter(function (c) { return c.inkwell || metaImp(c) > 0; }); if (inkOnly.length >= 6) arr = inkOnly; }
        return arr;
      }
      // Badge des onglets = nb de cartes réellement proposées (plafonné), pas la taille brute du pool.
      _lastPoolCounts = {
        personnage: Math.min(curate(pools.chars).length, SUGGEST_CAP),
        action: Math.min(curate(pools.actions).length, SUGGEST_CAP),
        objet: Math.min(curate((pools.objects || []).concat(pools.locations || [])).length, SUGGEST_CAP)
      };
      renderPhases();
      // Phase : onglet forcé par l'utilisateur, sinon auto (catégorie la plus en retard).
      var focus = _suggestPhase || autoFocusCat();
      var pool, focusLabel;
      if (focus === 'action') { pool = pools.actions; focusLabel = 'actions & chansons'; }
      else if (focus === 'objet') { pool = (pools.objects || []).concat(pools.locations || []); focusLabel = 'objets & lieux'; }
      else { focus = 'personnage'; pool = pools.chars; focusLabel = 'personnages'; }
      var cands = curate(pool);
      if (focus === 'personnage') {
        // Tri : (1) encrables d'abord si on en manque, (2) cartes dans la tranche de coût de l'étape
        // en cours (cohérent avec le plan), (3) les PLUS FORTES en tête (prix délirant pénalisé).
        var band = activeCharCostBand();
        cands.sort(function (a, b) {
          var ai = a.inkwell ? 1 : 0, bi = b.inkwell ? 1 : 0;
          if (needInk && ai !== bi) return bi - ai;
          if (band) {
            var ina = band[costBucket(a.cost)] ? 1 : 0, inb = band[costBucket(b.cost)] ? 1 : 0;
            if (ina !== inb) return inb - ina;
          }
          return suggestValueChar(b) - suggestValueChar(a);
        });
      } else {
        cands.sort(function (a, b) {
          var ai = a.inkwell ? 1 : 0, bi = b.inkwell ? 1 : 0;
          if (needInk && ai !== bi) return bi - ai;
          return suggestValueOther(b) - suggestValueOther(a);
        });
      }
      // BOOST MÉTA : les cartes clés de l'archétype remontent en tête, triées par importance (tri stable).
      if (hasArch) {
        cands.sort(function (a, b) {
          var ma = metaImp(a), mb = metaImp(b);
          if ((ma > 0) !== (mb > 0)) return mb > 0 ? 1 : -1;   // cartes méta d'abord
          if (ma !== mb) return mb - ma;                        // puis par importance méta
          return 0;                                             // sinon on garde l'ordre heuristique
        });
      }
      var top = cands.slice(0, SUGGEST_CAP);
      grid.innerHTML = '';
      if (!top.length) { grid.innerHTML = '<p class="ps-lcdb__empty">Aucune suggestion - ton deck est déjà bien fourni dans ces encres.</p>'; }
      // 🏆 sur les cartes clés de l'archétype méta (vraies cartes du deck top tier). Sinon, fallback : 3 meilleures par stats.
      else top.forEach(function (c, i) {
        var meta = metaImp(c) > 0;
        var tp = hasArch ? meta : (i < 3);
        var tt = meta && primaryArch && primaryArch.match === 'exact' ? ('Carte clé du deck méta « ' + primaryArch.name + ' » (Tier ' + primaryArch.tier + ')') : (meta ? 'Carte forte du métagame dans tes encres' : null);
        grid.appendChild(buildSearchCardLi(c, { topPick: tp, topTitle: tt }));
      });
      if (hint) {
        // Format identique à Pokémon : "{encres} · X/60 cartes · manque : {catégories}" (vraies données).
        var inkStr = effectiveInks().join(' / ');
        var miss = [];
        if (n.personnage < 40) miss.push('personnages');
        if (n.action + n.chanson < 14) miss.push('actions & chansons');
        if (n.objet + n.lieu < 6) miss.push('objets & lieux');
        var manque = miss.length ? ('manque : ' + miss.join(', ')) : 'deck complet ✔';
        var archPair = (primaryArch ? (primaryArch.name || '') : '').split(' - ')[0];  // « Améthyste / Saphir » sans le suffixe de stratégie
        var archLabel = (primaryArch && primaryArch.match === 'exact') ? 'Archétype méta' : 'Archétype recommandé';
        var archLine = primaryArch ? ('<span class="ps-lcdb__arch-tag" title="' + lzEsc(primaryArch.win_condition || '') + '">🏆 ' + archLabel + ' : <b>' + lzEsc(archPair) + '</b> · Tier ' + primaryArch.tier + '</span>') : '';
        // Les encres sont déjà dans le bandeau archétype → on ne les répète pas sur la 2e ligne.
        var inkPrefix = archLine ? '' : ('<b>' + lzEsc(inkStr) + '</b> · ');
        hint.innerHTML = archLine + inkPrefix + total + '/60 cartes · ' + manque;
      }
    }).catch(function () { if (hint) hint.textContent = 'Erreur de chargement des suggestions.'; });
  }

  // ─── Générateur : assemble un deck légal ~60 dans 1-2 encres ───
  function assemble(existing, pools) {
    var work = {};
    Object.keys(existing).forEach(function (id) { work[id] = { card: existing[id].card, qty: existing[id].qty }; });
    function total() { var s = 0; for (var k in work) s += work[k].qty; return s; }
    function add(c, want) { if (!c || isBanned(c)) return 0; var cur = work[c.id] ? work[c.id].qty : 0; var room = Math.min(want, 4 - cur, 60 - total()); if (room <= 0) return 0; work[c.id] = { card: c, qty: cur + room }; return room; }
    function bucketChars(b) { var s = 0; for (var k in work) { var cc = work[k].card; if (typeKey(cc) === 'personnage') { var bb = costBucket(cc.cost); bb = bb == null ? 0 : bb; if (bb === b) s += work[k].qty; } } return s; }
    function typeT(tk) { var s = 0; for (var k in work) { if (typeKey(work[k].card) === tk) s += work[k].qty; } return s; }

    var curve = { 0: 2, 1: 4, 2: 8, 3: 8, 4: 8, 5: 6, 6: 3, 7: 1 };
    var byCost = {}; (pools.chars || []).forEach(function (c) { var b = costBucket(c.cost); if (b == null) b = 0; (byCost[b] = byCost[b] || []).push(c); });
    Object.keys(byCost).forEach(function (b) { byCost[b].sort(charQuality); });
    [2, 3, 4, 1, 5, 6, 0, 7].forEach(function (b) {
      var tgt = curve[b] || 0, arr = byCost[b] || [], i = 0, guard = 0;
      while (bucketChars(b) < tgt && i < arr.length && total() < 60 && guard++ < 200) { if (add(arr[i], tgt - bucketChars(b)) === 0) i++; else if ((work[arr[i].id] || {}).qty >= 4) i++; }
    });
    // Actions / Chansons ~14
    (pools.actions || []).sort(genQuality);
    var ai = 0, g1 = 0;
    while (typeT('action') + typeT('chanson') < 14 && ai < pools.actions.length && total() < 60 && g1++ < 200) { if (add(pools.actions[ai], 4) === 0) ai++; else if ((work[pools.actions[ai].id] || {}).qty >= 4) ai++; }
    // Objets ~5
    (pools.objects || []).sort(genQuality);
    var oi = 0, g2 = 0;
    while (typeT('objet') < 5 && oi < pools.objects.length && total() < 60 && g2++ < 200) { if (add(pools.objects[oi], 4) === 0) oi++; else if ((work[pools.objects[oi].id] || {}).qty >= 4) oi++; }
    // Compléter à 60 : persos restants, puis filet actions/objets/lieux
    var pads = [(pools.chars || []).slice().sort(charQuality), pools.actions || [], pools.objects || [], pools.locations || []];
    pads.forEach(function (pool) { var j = 0, g = 0; while (total() < 60 && j < pool.length && g++ < 400) { if (add(pool[j], 4) === 0) j++; else if ((work[pool[j].id] || {}).qty >= 4) j++; } });
    return work;
  }
  function setAutofillBusy(on) {
    $$('[data-ps-lcdb-action="autofill"]').forEach(function (b) { b.disabled = on; b.style.opacity = on ? '.6' : ''; });
  }
  function autoFill() {
    var inks = suggestInkSlugs();
    if (!inks.length) { toast('Choisis d\'abord 1 ou 2 encres (ou un duo).', 'bad'); return; }
    inks = uniq(inks).slice(0, 2);
    setAutofillBusy(true);
    getPools(inks).then(function (pools) {
      state.cards = assemble(state.cards, pools);
      setAutofillBusy(false); afterChange();
      toast('Deck complété à ' + totalCount() + ' cartes ✔', 'ok');
    }).catch(function () { setAutofillBusy(false); toast('Erreur lors de la complétion.', 'bad'); });
  }

  // ─── Démarrage rapide par archétype (onglet Découvrir) ───
  function startArchetype(inkSlugs, name) {
    inkSlugs = (inkSlugs || []).slice(0, 2);
    if (!inkSlugs.length) return;
    if (!CUST || !$('[data-ps-lcdb-app]')) {
      try { localStorage.setItem('ps-lcdb-pending-arch', JSON.stringify({ inks: inkSlugs, name: name })); } catch (e) {}
      window.location.href = '/account/register?return_url=' + encodeURIComponent('/pages/decks-lorcana#construire');
      return;
    }
    goToBuild();
    state = { deckId: null, slug: null, name: name || 'Deck Lorcana', cards: {} };
    var ni = $('[data-ps-lcdb-name]'); if (ni) ni.value = state.name;
    setAutofillBusy(true);
    getPools(inkSlugs).then(function (pools) {
      state.cards = assemble({}, pools);
      setAutofillBusy(false); afterChange();
      toast('Deck « ' + state.name + ' » généré (' + totalCount() + ' cartes). À toi de l\'affiner !', 'ok');
    }).catch(function () { setAutofillBusy(false); toast('Erreur de génération.', 'bad'); });
  }

  // ─── Initialisation ───
  function init() {
    var root = document.querySelector('.ps-ldeck'); if (!root) return;

    // Restaure le deck local (sauf si on arrive avec ?deck=slug → on chargera le serveur)
    var urlDeck = new URLSearchParams(location.search).get('deck');
    if (!urlDeck && restore()) { var ni = $('[data-ps-lcdb-name]'); if (ni) ni.value = state.name; }
    recompute();
    if (urlDeck) { goToBuild(); loadDeckBySlug(urlDeck); }

    // Capture le panneau d'accueil pour le restaurer quand la recherche est vidée
    var resultsEl = $('[data-ps-lcdb-results]'); if (resultsEl) _welcomeHTML = resultsEl.innerHTML;

    // Recherche : debounce input
    var searchInput = $('[data-ps-lcdb-search]');
    if (searchInput) searchInput.addEventListener('input', function () { clearTimeout(searchTimer); searchTimer = setTimeout(runSearch, 280); });

    // Puces « cartes populaires » du panneau d'accueil → lance la recherche
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ps-lcdb-suggest-search]'); if (!chip) return;
      var term = chip.getAttribute('data-ps-lcdb-suggest-search') || '';
      var si = $('[data-ps-lcdb-search]'); if (si) si.value = term;
      runSearch();
    });

    // Bouton effacer la recherche
    var clearBtn = $('[data-ps-lcdb-search-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function () { var si = $('[data-ps-lcdb-search]'); if (si) si.value = ''; runSearch(); if (si) si.focus(); });

    // Filtres : toggle chips (encre / type / coût / rareté)
    [$('[data-ps-lcdb-inkfilters]'), $('[data-ps-lcdb-typefilters]'), $('[data-ps-lcdb-costfilters]'), $('[data-ps-lcdb-rarityfilters]')].forEach(function (grp) {
      if (!grp) return;
      grp.addEventListener('click', function (e) {
        var chip = e.target.closest('button'); if (!chip || !grp.contains(chip)) return;
        chip.classList.toggle('is-active'); runSearch(); recompute();   // recompute → tuto + plan suivent les encres
      });
    });

    // Filtre Encrier : exclusion mutuelle (encrable / non encrable) — clic = radio
    var inkwellGrp = $('[data-ps-lcdb-inkwellfilters]');
    if (inkwellGrp) {
      inkwellGrp.addEventListener('click', function (e) {
        var chip = e.target.closest('button'); if (!chip || !inkwellGrp.contains(chip)) return;
        var wasActive = chip.classList.contains('is-active');
        $$('button', inkwellGrp).forEach(function (b) { b.classList.remove('is-active'); });
        if (!wasActive) chip.classList.add('is-active');
        runSearch();
      });
    }

    // Score : toggle du détail (popover sous la pastille de la topbar)
    var scoreToggle = $('[data-ps-lcdb-score-toggle]');
    if (scoreToggle) {
      scoreToggle.addEventListener('click', function () {
        var bd = $('[data-ps-lcdb-score-breakdown]'); if (!bd) return;
        var willOpen = bd.hidden;
        bd.hidden = !willOpen;
        scoreToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        var bd = $('[data-ps-lcdb-score-breakdown]'); if (!bd || bd.hidden) return;
        var wrap = $('[data-ps-lcdb-score-wrap]');
        if (wrap && !wrap.contains(e.target)) { bd.hidden = true; scoreToggle.setAttribute('aria-expanded', 'false'); }
      });
    }

    // Résultats + suggestions : boutons +1/+4 → ajout (résolu via _cardIndex)
    function tileAddHandler(e) {
      var btn = e.target.closest('[data-deck-add]');
      var card = e.target.closest('.ps-lcdb-rcard'); if (!card) return;
      var c = _cardIndex[card.getAttribute('data-card-id')]; if (!c) return;
      var qty = btn ? (parseInt(btn.getAttribute('data-deck-add'), 10) || 1) : 1;
      addCard(c, qty);
    }
    var resultsWrap = $('[data-ps-lcdb-results]');
    if (resultsWrap) resultsWrap.addEventListener('click', tileAddHandler);
    var suggestGrid = $('[data-ps-lcdb-suggest-grid]');
    if (suggestGrid) suggestGrid.addEventListener('click', tileAddHandler);

    // Cartes du deck : conseil 💡 (toggle) + −/+/🗑 (contrôles sur .ps-deck-builder__deck-card)
    var deckWrap = $('[data-ps-lcdb-deck]');
    if (deckWrap) deckWrap.addEventListener('click', function (e) {
      var hintBtn = e.target.closest('[data-ps-lcdb-hint]');
      if (hintBtn) { var cat = hintBtn.getAttribute('data-ps-lcdb-hint'); var hint = $('[data-ps-lcdb-cat-hint="' + cat + '"]'); if (hint) hint.hidden = !hint.hidden; return; }
      var ctrl = e.target.closest('[data-deck-action]'); if (!ctrl) return;
      var card = ctrl.closest('.ps-deck-builder__deck-card'); if (!card) return;
      var id = card.getAttribute('data-card-id'); var cur = state.cards[id] ? state.cards[id].qty : 0;
      var a = ctrl.getAttribute('data-deck-action');
      if (a === 'inc') setQty(id, cur + 1);
      else if (a === 'dec') setQty(id, cur - 1);
      else if (a === 'remove') removeCard(id);
    });

    // Nom du deck
    var nameInput = $('[data-ps-lcdb-name]');
    if (nameInput) nameInput.addEventListener('input', function () { state.name = nameInput.value; persist(); });

    // Toolbar / actions
    root.addEventListener('click', function (e) {
      // Empty state : clic sur un duo → encres des SUGGESTIONS (ne touche PAS aux filtres de recherche)
      var duoPick = e.target.closest('[data-ps-lcdb-inkpick-duo]');
      if (duoPick) {
        _chosenInks = (duoPick.getAttribute('data-ps-lcdb-inkpick-duo') || '').split(',').filter(Boolean);
        _suggestPhase = null;
        recompute();                       // met à jour tuto + plan + onglets, sans modifier les filtres
        clearTimeout(_suggestTimer);       // pas de debounce ici : on veut une transition immédiate
        refreshSuggestions();              // l'intro disparaît net, les suggestions prennent le relais
        return;
      }
      // Empty state : clic sur une encre → ajoute/retire des encres de suggestion (max 2), filtres intacts
      var inkPick = e.target.closest('[data-ps-lcdb-inkpick]');
      if (inkPick) {
        var slug = inkPick.getAttribute('data-ps-lcdb-inkpick');
        var idx = _chosenInks.indexOf(slug);
        if (idx >= 0) _chosenInks.splice(idx, 1);
        else if (_chosenInks.length < 2) _chosenInks.push(slug);
        _suggestPhase = null;
        recompute();
        clearTimeout(_suggestTimer);       // transition immédiate (pas de résidu d'encres pendant le debounce)
        refreshSuggestions();
        return;
      }
      // Onglet de phase (Personnages / Actions / Objets) → cible les suggestions
      var phaseBtn = e.target.closest('[data-ps-lcdb-phase]');
      if (phaseBtn) { _suggestPhase = phaseBtn.getAttribute('data-ps-lcdb-phase'); renderPhases(); refreshSuggestions(); return; }
      // Plan de construction : déplier la liste / cibler une étape (via l'onglet de phase, PAS les filtres)
      var bpTog = e.target.closest('[data-ps-lcdb-bp-toggle]');
      if (bpTog) { _bpOpen = !_bpOpen; renderBuildPlan(); return; }
      var bpFind = e.target.closest('[data-ps-lcdb-bp-find]');
      if (bpFind) {
        var fTypes = (bpFind.getAttribute('data-types') || '');
        _suggestPhase = fTypes.indexOf('personnage') >= 0 ? 'personnage' : ((fTypes.indexOf('action') >= 0 || fTypes.indexOf('chanson') >= 0) ? 'action' : 'objet');
        renderPhases(); refreshSuggestions();
        var sg = $('[data-ps-lcdb-suggest-grid]'); if (sg) sg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }
      var act = e.target.closest('[data-ps-lcdb-action]'); if (!act) return;
      var a = act.getAttribute('data-ps-lcdb-action');
      if (a === 'new') { if (totalCount() && !confirm('Vider le deck courant et repartir de zéro ?')) return; clearDeck(); toast('Nouveau deck.', 'ok'); }
      else if (a === 'save') saveDeck();
      else if (a === 'buy') buyDeck();
      else if (a === 'undo') undo();
      else if (a === 'share') shareDeck();
      else if (a === 'export') exportDeck();
      else if (a === 'autofill') autoFill();
      else if (a === 'suggest-refresh') { _pools = {}; refreshSuggestions(); }
      else if (a === 'reset-filters') resetFilters();
      else if (a === 'draw-hand') drawHand();
    });

    // Filtres avancés : chapitre (select) · budget (slider) · en stock (checkbox)
    var setSel = $('[data-ps-lcdb-filter-set]');
    if (setSel) setSel.addEventListener('change', runSearch);
    var budgetEl = $('[data-ps-lcdb-filter-budget]');
    if (budgetEl) budgetEl.addEventListener('input', function () {
      var o = $('[data-ps-lcdb-budget-output]'); var v = parseInt(budgetEl.value, 10) || 0;
      if (o) o.textContent = v > 0 ? (v + ' €') : 'illimité';
      clearTimeout(searchTimer); searchTimer = setTimeout(runSearch, 280);
    });
    var instockEl = $('[data-ps-lcdb-filter-instock]');
    if (instockEl) instockEl.addEventListener('change', runSearch);

    // Verrouille la hauteur de la colonne recherche sur celle des filtres (jamais de débordement)
    var statsEl = $('.ps-deck-builder__stats');
    if (statsEl && window.ResizeObserver) { try { new ResizeObserver(function () { lockSearchHeight(); }).observe(statsEl); } catch (e) {} }
    window.addEventListener('resize', function () { clearTimeout(_lockT); _lockT = setTimeout(lockSearchHeight, 150); });
    requestAnimationFrame(lockSearchHeight);
    document.addEventListener('click', function (e) { if (e.target.closest('[data-ps-ldeck-tab="build"]')) requestAnimationFrame(lockSearchHeight); });

    // Mode Débutant
    var beginnerCb = $('[data-ps-lcdb-beginner]');
    if (beginnerCb) beginnerCb.addEventListener('change', function () { setBeginner(beginnerCb.checked); });

    // Étapes de construction (mode débutant) → applique le filtre de type
    var stepsWrap = $('[data-ps-lcdb-steps]');
    if (stepsWrap) stepsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.ps-lcdb__step'); if (!b) return;
      activeStep = parseInt(b.getAttribute('data-step'), 10) || 1;
      var types = (b.getAttribute('data-types') || '').split(',').filter(Boolean);
      setTypeFilter(types); renderSteps();
      var rw = $('[data-ps-lcdb-results]'); if (rw) rw.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    // Suggestions intelligentes : toggle ouvert/fermé
    var suggestToggle = $('[data-ps-lcdb-suggest-toggle]');
    if (suggestToggle) suggestToggle.addEventListener('click', toggleSuggest);

    // Démarrage rapide par archétype (onglet Découvrir)
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ps-lcdb-arch-start]'); if (!btn) return;
      var card = btn.closest('[data-inks]'); if (!card) return;
      var inks = (card.getAttribute('data-inks') || '').split(',').filter(Boolean);
      startArchetype(inks, card.getAttribute('data-name') || 'Deck Lorcana');
    });

    // Restaure le Mode Débutant + consomme un archétype en attente (retour de création de compte)
    try { setBeginner(localStorage.getItem('ps-lcdb-beginner') === '1'); } catch (e) {}
    if (!urlDeck) {
      try {
        var pa = localStorage.getItem('ps-lcdb-pending-arch');
        if (pa) { localStorage.removeItem('ps-lcdb-pending-arch'); var o = JSON.parse(pa); if (o && o.inks) startArchetype(o.inks, o.name); }
      } catch (e) {}
    }

    // Bibliothèque : la carte entière est un lien (?deck=slug → ouvre dans Construire au reload).
    // Ici on ne gère que la poubelle (confirmation → deck-delete → retrait de la carte).
    var libGrid = $('[data-ps-lcdb-library]');
    if (libGrid) libGrid.addEventListener('click', function (e) {
      var del = e.target.closest('.ps-deck-hub__card-delete'); if (!del) return;
      e.preventDefault(); e.stopPropagation();
      var slug = del.getAttribute('data-deck-slug'); if (!slug) return;
      var name = (del.getAttribute('data-deck-name') || 'ce deck').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      confirmToast('Voulez-vous vraiment supprimer « ' + name + ' » ?', function () { deleteDeck(slug, del); });
    });

    // Panneau « Suggestions intelligentes » FERMÉ par défaut à l'arrivée (parité Pokémon).
    // L'utilisateur l'ouvre lui-même via le bandeau ; toggleSuggest() peuple alors le contenu.

    // Si on arrive directement sur l'onglet Bibliothèque
    if (document.documentElement.getAttribute('data-ps-ldeck-tab') === 'library') loadLibrary();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
